<template>
  <div class="block">
    <el-tag>选择账户： </el-tag>
    <div class="block">
      <el-cascader
        v-model="userUalue"
        :options="options1"
        filterable></el-cascader>
    </div>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择汇总方式：</el-tag>
    <el-select v-model="value" placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-divider direction="vertical"></el-divider>

    <el-tag>选择层级：</el-tag>
    <el-select v-model="values" placeholder="请选择">
      <el-option
        v-for="items in level"
        :key="items.value"
        :label="items.label"
        :value="items.value">
      </el-option>
    </el-select>
    <el-divider direction="vertical"></el-divider>

    <el-tag>输入起止日期：</el-tag>
    <el-date-picker

      v-model="value1"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyyMMdd"
      :picker-options="pickerOptions"
      @change="chooseTimeRange">
    </el-date-picker>
    <el-button type="primary" v-on:click="exportExcel" round>导出</el-button>
    <el-button type="primary" v-on:click="getDataList"  :disabled="isDisable" round>查询</el-button>
    <el-button type="primary" v-on:click="getDataList1"  :disabled="isDisable" round>一键调整</el-button>

    <el-divider></el-divider>
    <el-table
      XLSX.uitls.table_to_book
      stripe

      :default-sort = "{prop: 'date', order: 'descending'}"
      :data="datas"
      id="exportTab"
      :summary-method="getSummaries"
      show-summary
      style="width: 100%">
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="campaignName"
        label="计划名称"
        width="180">


      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupId"
        label="广告组ID"
        width="100">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupName"
        label="广告组名称"
        width="200">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['CAMPAIGN','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="campaignId"
        width="120"
        label="计划ID">
      </el-table-column>
      <el-table-column
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementName"
        label="广告名称"
        width="300">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        prop="creativeId"
        label="创意ID">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="placeType"
        label="广告位类型">
      </el-table-column>
      <el-table-column
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="cvType"
        label="转化类型">
      </el-table-column>
      <el-table-column
        prop="uuid"
        width="120"
        label="账户id">
      </el-table-column>
      <el-table-column
        sortable
        prop="nameid"
        width="120"
        label="名称">
      </el-table-column>
      <el-table-column
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"

        prop="campaignId"

        width="140"
        label="计划id">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        prop="disGeneralBalance"
        width="130"
        label="现金">
      </el-table-column>
      <el-table-column
        sortable
        prop="showCount"
        label="曝光量"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="clickCount"
        label="点击量">
      </el-table-column>
      <el-table-column
        prop="CTR"
        :formatter="ChangeToPercentage"
        label="点击率">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        width="110"
        prop="spent"
        label="花费">
        <template slot-scope="scope">
          {{scope.row.spent}}
          <i class="el-icon-edit" @click="chujia(scope.$index,scope.row)"></i>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="dailyBudget"
        :formatter="rule1"
        label="日限额">
      </el-table-column>
      <el-table-column
        sortable
        prop="but"
        label="cpc数据"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="customPayCount"
        label="自定义付费数">
      </el-table-column>
      <el-table-column
        sortable
        prop="zdyff"
        label="自定义付费成本">
      </el-table-column>
      <el-table-column
        sortable
        prop="addDesktopCount"
        label="加桌数">
      </el-table-column>
      <el-table-column
        sortable
        prop="zdylh"
        label="加桌成本">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="timerule"
        prop="reportDate"
        label="日期">
      </el-table-column>
      <el-table-column
        :formatter="rule1"

        prop="xe"
        label="账户日限额">
      </el-table-column>
      <el-table-column
        sortable
        prop="CVR"

        :formatter="ChangeToPercentage"
        label="加桌率">
      </el-table-column>

      <el-table-column
        sortable
        fixed="right"
        label="计划状态"
        prop="pauseState"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.pauseState"
            :active-value="0"
            :inactive-value="1"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="changeSwitch($event,scope.row,scope.$index)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="170">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">设置时段</el-button>
          <el-button @click="edit(scope.row)" v-if="dingshi" type="text" size="small">日期</el-button>
          <el-button @click="edit1(scope.row)"  v-if="xiane" type="text" size="small">限额</el-button>

        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="修改日限额" width="500px"  :visible.sync="dialog">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="全天开启" >
        </el-tab-pane>
        <el-tab-pane  name="second" label="七点后开启">
        </el-tab-pane>
        <el-tab-pane  name="second1" label="八点后开启">
        </el-tab-pane>
        <el-tab-pane  name="second2" label="八点半后开启">
        </el-tab-pane>
        <el-tab-pane  name="second3" label="九点后开启">
        </el-tab-pane>
        <el-tab-pane  name="second4" label="九点半后开启">
        </el-tab-pane>
        <el-tab-pane  name="second5" label="十点后开启">
        </el-tab-pane>
        <el-tab-pane  name="two" label="十一点后开启">
        </el-tab-pane>
        <el-tab-pane  name="two2" label="十四点后开启">
        </el-tab-pane>
        <el-tab-pane  name="two4" label="十六点后开启">
        </el-tab-pane>
        <el-tab-pane  name="two5" label="十七点后开启">
        </el-tab-pane>
        <el-tab-pane  name="two6" label="十八点后开启">
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="updateEd(form)">确 定</el-button>
      </div>
    </el-dialog>




    <el-dialog title="修改开启时间" :visible.sync="dialog1">

      <el-tabs v-model="activeName1" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="长期投放" >
          <span class="demonstration">开启日期</span>
          <el-date-picker
            v-model="value3"
            type="date"
            align="right"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-tab-pane>
        <el-tab-pane  name="second" label="指定开始和结束日期">
          <el-date-picker
            v-model="value1"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="chooseTimeRange">
          </el-date-picker>
        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog1 = false">取 消</el-button>
        <el-button type="primary" @click="updateTime(form)">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改日限额" width="500px"  :visible.sync="dialog2">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="不限" >
          <el-tag>不限制任何额度</el-tag>
        </el-tab-pane>
        <el-tab-pane  name="second" label="自定义">
          <el-input v-model="money" style="width: 30%" placeholder="请输入内容"></el-input><el-tag>元/天</el-tag>

        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog2 = false">取 消</el-button>
        <el-button type="primary" @click="updateEd1(form)">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改出价" width="500px"  :visible.sync="offer">
      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane  name="first" label="自定义">

          二阶段出价： <el-input v-model="money3" style="width: 30%" placeholder="请输入内容"></el-input><el-tag>元/转化</el-tag>
        </el-tab-pane>
        <el-tab-pane  name="two" label="一键起量">
          起量预算： <el-input v-model="moneys" style="width: 30%" placeholder="请输入内容"></el-input><el-tag>元</el-tag>
          <el-button type="primary" style="width: 20%" v-if="qiliangcode===0" @click="SendOffer1(form)">开启</el-button>
          <el-button type="primary" style="width: 20%" v-if="qiliangcode===1" @click="SendOffer2(form)">关闭</el-button>

        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click="offer = false">取 消</el-button>
        <el-button type="primary" @click="SendOffer(form)">确 定</el-button>
      </div>
    </el-dialog>





    <el-dialog title="批量修改开启时间" :visible.sync="dialog3">

      <el-tabs v-model="activeName1" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="长期投放" >
          <span class="demonstration">开启日期</span>
          <el-date-picker
            v-model="value3"
            type="date"
            align="right"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-tab-pane>
        <el-tab-pane  name="second" label="指定开始和结束日期">
          <el-date-picker
            v-model="value1"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="chooseTimeRange">
          </el-date-picker>
        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog3 = false">取 消</el-button>
        <el-button type="primary" @click="updateTime1(form)">确 定</el-button>
      </div>
    </el-dialog>
  </div>


</template>



<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
import {excel} from  '../until/excel';
export default {
  data() {
    return {
      timetop:'',
      dialog3:false,
      offer:false,
      form:{},
      xiane:true,
      activeName: 'first',
      activeName3:'first',
      activeName1: 'first',
      value3:'',

      dialog1:false,
      dialog:false,
      dialog2:false,
      valueFlag:0,
      flag:0,
      userUalue:'',
      isDisable:false,
      options1: [
        {
          value: 'xiaobai',
          label: '测试',
          children: [{
            value: 'csyh',
            label: '测试客户',
          }],
        }

      ],
      options: [{
        value: 'DAY',
        label: '按天汇总'
      }, {
        value: 'HOUR',
        label: '按小时汇总'
      }, {
        value: 'SUMMARY',
        label: '汇总'
      }
      ],
      value: '',
      level: [{
        value: 'ACCOUNT',
        label: '账户层级'
      }, {
        value: 'CAMPAIGN',
        label: '计划层级'
      }, {
        value: 'GROUP',
        label: '广告组层级'
      },
        {
          value: 'ADVERTISEMENT',
          label: '广告层级'
        },
        {
          value: 'CREATIVE',
          label: '创意层级'
        }],
      /*
      小邱
       */
      csyh:['账户id1','账户id2','.....'],
      csyhtoken:['xxxxx'],





      modj:[
        '5c8274c3669bebd1daff',
        '6e667f3d41baf2558609',
        'd9532640b51ea8679927',
        '09bfc4f79bc7ab5266db',
        'fb52572c7bb80c7be7b3',
        'a55cd95d0e13548edcc3',
        '926ca248069a653f16d3',
        'd4c37a1ef4a475870ed8',
        'e09cf8760213a34fccb7',
        '100365a6950c285d2302',



      ],
      xgjc:['f10da5d17be36f05d56a',
        '3c6e43634e3f3c84ef0a',
        'c77a14dcbd9ca39f1212',
        '6dce85765c6b68215492',
        '17406c47d330aa6bed60',
        '3be62066e5426efbf96e',
        '8c3faad14679550e0c96',
        'd88cb764c91500e6676c',
        'ec3abf2004c848a358b9',
        'b293e91d7e647ec29af9',
        '0a8fcc5c49ffb3eaac19',
        '48402a1a01c7f680cfa9',
        '04479ae42d91f7a5842d',
        '8268ee32f467435169f8',
        '924a2986c4e9005a6833',
        '60cf8e5a6c9cf8664344',
        '088244e41bd37b4d62f3',
        'e57c38d231eb99469cf9',
        'c7705aa08e2b88d78564',
        '8821e2e5179df8063e54',],
      xgjctoken:[

        '3a2dc6872c899601a2d5b470cdf797284007eebce43e275e85dc484ed03d0aa5'
      ],

      jhcm:[
        'c12ceb103ca10929fd84','210044931094029aa313','0f43fdaeb51ab4b1d0e3','25e642008213def5eaa4','ed79d501e7a3f9a6c268'

      ],
      jhcmtoken:['6965266afe9d0da5b242c9e9ce53605d7e6a23acbb21d74a047d31c4d03e1559'],
      modjtoken:['29d59c7ddf734ef6f4c9de4b882e946a60f31aea5b76cb2695ca31e8261a832c'],

      fhxs:[
        '8abd39c69363441438cd',
        'a7974b1205ee8c1f8d18',
        '41c5891247bb7396cd90',
        '6b47400d8a2c177ee92d',
        '91bcdf78f1197af9d9f1',
        '0086ee3696e1b89fe06e',
        'e61314e57fec6767d025',
        '2e2215ad388f9a8672f5',
        '6753c74c45e7a7a3f098',
        'b8580b1e2ee4603de18f',
        'd0510aec37d1c084fa9f',
        '28237f9b0cbefe2d2cb4',
        'f0a1a5724f302f39dad6',
        '41f3764394629e09333a',
        '70d4401ed627c49b6485',
        '8522d44ba6fa937e143a',
        'faeb2cbc5a26886b79bb',
        'a304f863c07f61e75df5',
        'ccb879749df9d0afa08c',
        '7f10c577c36fbcd5dee5',
        '25dcead535138bdc4e95',
        'ff574d3de82bf57576c4',
        '9d92c26ccdadb375c428',
        '40ae7bbed9d46a0f4e70',
        '349413fe0fe29a01d8f6',
        '3bf0668022af1823d5b5',
        'c9827c6f0817cc5c82bc',
        '03eed9e2cd41077021cd',
        'b880933e9611512c6d0f',
        '98b4cf4f10b8897a27a2',
        '0422e48f8dd3da12ccb3',
        '6a399cf365e7aec36084',
        '33c482c907229e942c20',
        'f5dfae0dbffe79e235ae',
        '691f7cc133ddc8b2d335',
        '83dfd40bc360c426ff98',
        'cbd3fd2f333b85a04ca1',
        'c05da2cac5d07c6debff',

        '691f7cc133ddc8b2d335',
        '83dfd40bc360c426ff98',
        'cbd3fd2f333b85a04ca1',
        'c05da2cac5d07c6debff',
        '47b34fdd9eda178b99bb',
        '232e064ff8c0d1f24294',
        '4f87e4b91ba672049b52',
        '4d576fbdf99fb6b6ba0d',
        '20ec060d03cb5c4330c4',
        'd4d181e230fadfdf9f7f',
        'dae242ff545a04cf2ca6',
        'bebe383ab9fd256ae4a2',
        'f05ad769b448940a04d4',
        'b876c4c03f9e72f0eb4b',
        'afb6a78bd8ba7222cdaf',
        '4ee21d7de23879e8a777',
        '5b5f6bb9760375667b2b',
        'c958635b557ac6c07669',
        'cb006197e3ab8b7a8f68',
        '4d1e2e975800673a82f3',
        '7e1b78de985e803bfc6b',
        '9975729ad360ce7ba596',
        '16402b565560fad914e2',
        '7aca936cd29b2e376586',
        '0335588f8808ce84a1bd',
        '4d1178109b2f273ff897',
        'ff55faa2ecef85018837',
        'a8a260164a3f9cf44a7f',
        'dc7338db9b2f31767112',
        'c28b6318397b375d24de',

      ],


      fjsktoken:['66bb2ed65ecacf5596501df47ff186eb9a3bafa160a1cf40fdf293b6d9f72be2'],
      fjsk:[

        'cbe8f3320c6b471bc336',
        '39707f5d389d17db9bfe',
        '93b5679cd0993499350f',
        '1f0dc61ec0ee79cdf956',
        'debbd6151ce5c0de6903',
        'b3d83635899ba3ec1713',
        'b1f0b7b2c5e180b23725',
        'ef7a6b73775d2f56b603',
        'f25e0199d1a6686901a5',
        'c733980d03cdfa8ce8ab',
        '22473a5a91f3100001d9',
        '26b8f2be8a06b105d6db',
        'b65cfd3462ba5979e79f',
        '07e30e6f35a8fc29b26e',
        '89e0f006265feb5cb909',
        '187c0e55884bee09051b',
        'dc358e895caee2a64174',
        '3138999731d821602216',
        'f7eb9ea6221d600829fa',
        'db247daba041f66c7657',
        '11a11464f624b6a6be05',
        'a31658aea4329b764e6f',
        '137ebd83f29d5c57ebc2',
        'ff08d0f6bd189e65153f',
        '555c1a57751b8297e475',
        '075bb53c2b4da40ef3d2',
        'ebf270f674207038c5e5',
        'd2f0b9e9a4739173a6cc',
        'f8095f711f8b3536da4c',
        '6a81c1105e4d23badc43',
        'be8c5775a0ab69237c35',
        'a62bcf8b7489c2688868',
        '498544b2ce55bb2b6f1d',
        '525b28a4ee5f565fa7ed',
        '9b8506f57eab0d96c492',
        '93da5afc4a3a503bdfe4',
        'bd394e5d7457194ec8b1',
        '198b9636ff0bd5f290e9',
        '30b260a60d0c73a6c709',
        'b4e8aada4bd47951461c',

      ],




// hmxs:['a5a031d51f457068eee5'],
      fhxstoken:['1e0bba549c415e65e9f2155dd419d627a7ae6893cf58898eb6a6320fb438e2b0'],
      hmxs:[

        '242b696a31b23cb9b1bd',
        '51a175dd7cd74415fd39',
        'f5b9071a68a757a214d3',
        '39567a17add5812f69e2',
        '5bf5191af21b2d4e48d3',
        '03b84824f842f41e2824',
        'c5a1346c8bf5e45f3c07',
        '6cdb193a02fd8f8ec643',
        '2fe4afb611d6c6254a32',
        'cc75df9974c775353b3f',
        'd6e7cd65667a52647dc6',
        '330c282e989c85b1e856',
        '6d3b6765750a03124e1d',
        '700db50e744d0720e7e1',
        '9e4c6109e94aad9a7d0c',
        'dde9a2fcfb25f6bd963f',
        '5074960eb934161041f8',
        '089fd71cd6f51bdc4018',
        'f09c91899448f50f2a26',
        'c7be87f4a9adbb1eedcd',
        '35a59465b0e1a418d877',
        'd8cd93defce0f3040b25',
        '9f918ceecc97c65947e7',
        'dffc0130d9e3c524131c',
        '70b26bcedddc2c9bbb2f',
        '5afeeb4170e04abb8a41',
        'a240d1655b80577e380f',
        'dd272032926d474b4f9f',
        '607222f560c1cd6e7ddf',
        'b4d7d2a3aa2379645168',
        'e415c5be184412951746',
        '57e462cbc7f8b3fb8efb',
        '6d13ecaedea66279a282',
        'e017519b4b81d4bde227',
        '07efc50fa7651af5acbf',
        'dcea4805bb1f83d9ade6',
        '82146f4d18100168c1fb',
        '64fb7b283c7f1e8cd2f3',
        '82e74f816dc4aaf13e11',
        '305de1d029cbd6b07050',
        'f192e51bd164b333a7cd',
        'c3f15d00948edd61edb9',
        'f8e691369d51680ce6ab',
        '63e4c5a68df09f28fd3a',

        'b415fa428ffbd8ad2b60',

        '58c14cdc0810b4c682b0',

        'd9b90dd66f5ded6d0121',

        '6841c11b1fa641de0148',

        'e21e20eee3211d485911',

        '791eacc276ebf8b21009',

        'f614c60da50abed521da',

        '1bc1b55b00e6b1c0d103',

        'e1b3986591f2e8b88e7a',

        '6420566311d74a2776c2',

        '94d7298687e8361b90b7',

        'f4678b7761b1a39052c6',

        '7ab1e8c5b1d0a105888e',

        '84567b4141d5dcfb3086',

        'd6445219775094fa46bd',

        'c282f6e4a332ce8df19b',

        '93fa65bebba9d1fe13cc',

        '620b909dc19f21574727',

        'a5f4006c12c7c48840f5',

        '5ae4ae27d1fb9b88da8f',

        '8aa7ca742fec2d29cb30',

        '0bf6bbe6e472721ca313',

        '34527b41ccfc6a58d079',

        '063d21841f45f3790cd9',

        '9db4117e2a5c019a1a9e',

        'd35d672e9be1a2223305',

        '9edc38c2142b1824c285',

        'd0ae14c4b16ea914ce3e',

        '3386a9821dea34c5bf35',

        '6ad6b58d924421dc8940',

        '3da2fe55b966430c19a9',

        '06b0f2dbbc799711a41e',

        '643ecfd97113efb0bb80',

        '41cd63277389a2ddf9ef',

        '84988e2ecb9ab0051b08',

        '82151088bf9fa5c09a6a',

        'e9c7e803130b4d8a3c3a',

        '493408214c87b6b0c8ba',

        '53aa4b34cebd95424789',

        '31c801f49ef2a6599290',

        '2d2e1c00bfbd78d7c804',

        'be9494fc1b03ad924334',

        '9553f101124dd6a02fd2',

        'f3f0f476c3215208b5dd',

        '795e2f71670c11ed26e6',

        'a8054c6ae185571629b0',

        '149d3ff15f71cccc13be',

        'ec1b7a4f0d7e6998e9b1',

        'b50b81fc12497f9999c9',
        '2fef2e0923b04d0facc1',

        'f834159ff5377d217a8f',

        'f628c0eff40e0a21e013',

        '2636b0922c9a2d7b71f8',

        '5f86c5078c3654cbeabb',

        '8936ddb2eb522183e21b',

        'b09cd253f1fd2852d995',

        '99bd629fa8ab25bed090',

        '8385698cd8d6fee8c10d',

        'c50efdfd4b75eda13e73',

        'd2a4d03852a5bcff913d',

        '95f2c647a6f51204aee0',

        'a40efc4be80bea3f0a73',

        '886f3805379d9a11a905',

        '1e9ada22bb168d41fb76',

        '034832df114b5428694f',

        '6098dae9274c15f55ba1',

        '92aaf2de96073ee0263c',

        '1fe82e2752584814bfa8',

        'bdf1949147ebe1eaeb41',

        'e9c35cb48b91fa4e940d',

        'd2f43bfee0f6bd1ec4aa',

        'fa11398edfed6b743dde',

        'eba4c02f5cfb8b759221',

        '931a22fa1ea4da797ca0',

        '99d9f5f7f0818a9926d7',

        '73735fe6b29a9a1717c2',

        '48f0172c45c90f152317',

        'fcbe799ec35e8d55c9d6',

        'c5eaa1054182fed6f164',

        '1c570cbea758226ec6ce',

        '57853f80fe1fcd65061c',

        '4100e60fce532b9b90ce',

        '63f10253ff8d91400cb4',

        '9d1ba9e1aa26b1382e94',

        '3b2e3eef1abedf30b988',

        '0d08b9f6da328388d902',

        'a8f58309494258929579',

        '9c990ba774e0f0c77e9d',

        '454856fc01f4fbc623e9',

        'd036c33476fb7342ace0',

        'c26398258d9e64372eaa',

        'aab3b440724f448d780b',

        'bf77af326ac194c89989',

        '805f94f55759b11a5fb6',

        'eab7b6b9f78cd15041fc',

        '2eaf0e3d4909731d298a',

        '67f5f34150af74c27fbb',

        '69852a1b604ad84fb28a',

        '7a3f65160f26af1f0b11',

        '323e3c667f828a5e9141',

        '8bc37922b23865feca5e',

        '7265b2b9fdf5d342ebbd',

        'a976a28cf00d703768b6',

        '283e817387a84e5a26d2',

        '90213c98a68dc12f2b56',

        'e56d3aa976c2de027835',

        'b463e0407131205bfb85',

        'dca8cfa2e182f5da5cc1',

        '604d74d3aad928830044',

        '0c2c1d4f0795338a379e',

        '0c79aa09f65bd3e2f777',

        '4aa72c73fb86fb8424b2',

        '9a7b9534e16ce0af5f4e',

        '6b3b181c13c2f6330b7a',

        '4a88c7b794c9e6477625',

        '910d7e67857fc332577b',

        'f8de6e3b964397c791db',

        '79c70abbcd19d570927b',

        '5dafa61f3c141f835116',

        '0a5710e35054a81e3da0',

        'a1b67cb6ec8091365059',

        '0c2d59edf057d7c28fc1',

        '870847fbc6f13af568bb',

        '88bd1911f8dc45ee8dd9',

        'cd5c3eb249a1147503cd',

        'e2cb91dfd7ef1dbeb5d7',

        '26a66384acc812594e63',

        '8ef8387cdd5c0848929e',

        '81cac62844b0bef25703',

        '8ad3c9523b055126e140',

        '1a911908d9e41d314093',

        '9568f554c7eb773996c6',

        'dfabd87ffca9c0456303',

        'b0d01c3bcebf14976725',

        '368339bd9e43526b5fe2',

        '196cde6e1bf33ed67b06',

        'a44206b788e0bf7c36ee',

        'cefd77386e5477942c14',

        '7091bd98fcca731f1abe',

        'af44401bc93248794a1e',

        '614ce57ad64a824e9dcd',

        'cbaa6ce7f906ffa5e525',

        '610ccc302e6d6f02f4bb',

        'e7f9c6038ec427b656d4',

        '079f658cbb869e43429d',

        'e604cf7d8dfb9fe71585',

        '466174d64654967f20b2',

        '502ad6a235b34f97e7a9',

        'b95978040cb7155eed56',

        'e303608846d96e8117f0',

        '1c9e928988762cbebf58',

        '561d2f55e10cdf193a73',

        '0818be57d5018b249a72',

        '6619eb4c334d507d9a63',

        'ac2861d49e3545b30482',

        '975b38aed31453c78a63',

        'cabf4f72e74439c1cb40',

        '008fe2eaf82912ceb131',

        'ed45cdd8a58dc7b3eef2',

        'b7213bef753ed65972cb',


        '90d2d56fd148ae4e131a',
        '956f90cd465fb1cb3743',
        '10d82fb4c97df567e64b',
        'c10ca5e2b47081c0ec2e',
        '54dc07ed67a34239f366',
        '98a2df2364e9b143aa9d',
        'ef0d787fc628034612a8',
        'fc41aecc079a3813e7a1',
        '7bdc8523711ac5a9f712',
        'eb0a4ff8791bdbe75c10',
        '396e5b8b14807116d79f',
        '083e8d3a34f92aadaca5',
        '48da835957b04627af32',
        'b3eca6b01f7477095645',
        'c00ea68fc44196d28b76',
        '2ce502cf46d54786b2a1',
        'e2af6fb1560566dee713',
        '317a4e3294070f1fc46a',
        'a902e2e4dc693bc113b1',
        '79c8d7cde55d5fbcd2c3',
        'f06de8fa5cafd6541d76',
        'cf715b3cba453443e646',
        '0539a377fe98b522a6d5',
        '24088457edd66402ec34',
        '4a7527b7454912540240',
        '2d4feb4284a4991d85b1',
        '723f97c5873e8399d281',
        'b6de9b937e85a8fcea33',
        '2c0610ecb6e7a55df5fc',
        'e550822dd75f5f7f89a7',
        'be1b61d06075d57b06e5',
        '927c6df9320e414f080b',
        'c529debc20c647d452c5',
        '8502e73f0e4eb16bc585',
        'ca537304afa84c29f8cf',
        'f6d6d86248144bb7a0a8',
        '54f2589567a2dd296eb5',
        '26de40580686554ee35b',
        'c9b248750d62b8287b4e',
        '8e173e839c06b807b31f',
        '361d158baa7fa23f8ebb',
        'b7213bef753ed65972cb',
        '90d2d56fd148ae4e131a',
        '956f90cd465fb1cb3743',
        '10d82fb4c97df567e64b',
        'c10ca5e2b47081c0ec2e',
        '54dc07ed67a34239f366',
        '98a2df2364e9b143aa9d',
        'ef0d787fc628034612a8',
        'fc41aecc079a3813e7a1',
        '7bdc8523711ac5a9f712',
        'eb0a4ff8791bdbe75c10',
        '396e5b8b14807116d79f',
        '083e8d3a34f92aadaca5',
        '48da835957b04627af32',
        'b3eca6b01f7477095645',
        'c00ea68fc44196d28b76',
        '2ce502cf46d54786b2a1',
        'e2af6fb1560566dee713',
        '317a4e3294070f1fc46a',
        'a902e2e4dc693bc113b1',
        '79c8d7cde55d5fbcd2c3',
        'f06de8fa5cafd6541d76',
        'cf715b3cba453443e646',
        '0539a377fe98b522a6d5',
        '24088457edd66402ec34',
        '4a7527b7454912540240',
        '2d4feb4284a4991d85b1',
        '723f97c5873e8399d281',
        'b6de9b937e85a8fcea33',
        '2c0610ecb6e7a55df5fc',
        'e550822dd75f5f7f89a7',
        'be1b61d06075d57b06e5',
        '927c6df9320e414f080b',
        'c529debc20c647d452c5',
        '8502e73f0e4eb16bc585',
        'ca537304afa84c29f8cf',
        'f6d6d86248144bb7a0a8',
        '54f2589567a2dd296eb5',
        '26de40580686554ee35b',
        'c9b248750d62b8287b4e',
        '8e173e839c06b807b31f',
        '361d158baa7fa23f8ebb',
        '86334d6cd5dee0c16b56',
        'ae878d1ea88a33305a21',
        '10cd333baddb3117d28f',
        '2cd405396549a285aa33',
        'a1496e316dac707c1255',
        '63782e6b6b96330a185b',
        '4c8847f22d756b776b4d',
        '372943cab63c031a2c06',
        'abdcae5add238a1130cd',
        'c68b096c41e99ccc6aa6',
        '10aeb10ab43e959b218f',
        'eb8942f074dffd36558e',
        'cfe30d0e6fbebbafe9a5',
        '9851cd566e5a6462ce45',
        '000fa2f4fa39cb135ddf',
        '1636575809016f76aa27',
        'f691fb72ecd7a8016a5d',
        '00feadb2602d0cb425d9',
        '5ee03a75888371269237',
        '6ebf838b0c1841df3e46',
        '513803aa37c3fd99ac74',
        'c721a537c4f4a0607962',
        'a9e120145a9fb979b1ea',
        '4b89412f07935e6834eb',
        '19a500e783371b345857',
        '2c0573d55ac125374030',
        '5ab9bab8c6f62097e860',
        '5ede7e219ba437eb4e80',
        'c6976921edc11b0a1353',
        '97d7cc6eae711bf0d6ed',
        '489c9fd304d934600dc2',
        '5dbd344d11d26db0f116',
        '304146e7340876e9149e',
        '26299b55eb408440aac9',
        'ae07f72f378147c3cc18',
        '13e331d1dc28d9d81c4e',
        'b637176cf7f294507c87',
        '5b0351353f7a2e4b37c7',
        '46c42e22583edff31e65',
        'f68694839a55f1206bdc',
        '72331a20373840b331da',
        '6ec2761110f349ab00a6',
        '56cd772b16335f505f10',
        '62c15c6ea25ba0642351',
        '7869eb5a71faa8876d1b',
        'fce091963a344ac04787',
        '93fef655105e51bba913',
        'd3431fd8d323ef226f9e',
        'c3973eb2fae265fedc8c',
        '61ae13226fb73eaabe4a',
        '4e1ade5fc18c89cf2c99',
        'd1f60ec81daf1abafb42',
        '50f33be62a56c70270e6',
        'ffa66470c392eaf82af3',
        '180268c2534d684b28b3',
        '9c1f7da797d2907cdf58',
        'b60c245d2a6d962fc364',
        'd4bb0e29b903cdf9d889',
        'feaed1ca9bcb04ce0105',
        '3508ee9897079b95506e',
        '3f74f07ee209a6d17bb4',
        '35bc93dff55fc8191470',
        'c3de52b70cd9cc229791',
        'dd9dba2d84c4bc4387a3',
        'a93d9dec166174f298e0',
        '06b34d44ed16ebb2e33e',
        'afd60d7813daeb45a5a6',
        'f6f4ea661116483b0fae',
        '38350a64e793e726c2a0',
        '50456fcb8401cbd3a86f',
        'd9404bbfe03f1c36e68f',
        '458b67a8479dc8907132',
        '18f1e64e69517871a516',
        'f1e9333936c6f5b623e5',
        '83313e1904657dc40d27',
        '83a339ddcb8014b4c949',
        '43109218d4ed793fb145',
        'c7da99079b41454130db',
        'b1b102b98b5d7bd2c1f4',
        '545cefa649547416d8f6',
        '84fa5c9ca2cc3f76cfad',
        '55a33a5cfd09b8eb5bdc',
        'b3b7f01c6361c6ff1c4a',

      ],









      hmxstoken:['99ad52c9f6ffc7df551d6996d94d8717d3aaba4cd4ba7c0552744fb861709fe9'],
      xqqhmxs:[
        '67f5f34150af74c27fbb',
        '69852a1b604ad84fb28a',
        '604d74d3aad928830044',
        'f8de6e3b964397c791db',
        '79c70abbcd19d570927b',
        '5dafa61f3c141f835116',
        'e2cb91dfd7ef1dbeb5d7',
        'c00ea68fc44196d28b76',
        '2ce502cf46d54786b2a1',
        'e2af6fb1560566dee713',
        '317a4e3294070f1fc46a',
        'a902e2e4dc693bc113b1',
        'cf715b3cba453443e646',
        '0539a377fe98b522a6d5',
        '24088457edd66402ec34',
        '4a7527b7454912540240',
        '2d4feb4284a4991d85b1',
        '9851cd566e5a6462ce45',
        '000fa2f4fa39cb135ddf',
        '489c9fd304d934600dc2',
        '5dbd344d11d26db0f116',
        '304146e7340876e9149e',
        '26299b55eb408440aac9',
        'ae07f72f378147c3cc18',
        '82e74f816dc4aaf13e11',
        '5ae4ae27d1fb9b88da8f',
        '8aa7ca742fec2d29cb30',
        '0bf6bbe6e472721ca313',
        '063d21841f45f3790cd9',
        '9db4117e2a5c019a1a9e',
        'd35d672e9be1a2223305',
        '3386a9821dea34c5bf35',
        '31c801f49ef2a6599290',
        '2d2e1c00bfbd78d7c804',
        'be9494fc1b03ad924334',
        '9553f101124dd6a02fd2',
        'f3f0f476c3215208b5dd',
        '795e2f71670c11ed26e6',

      ],
      xqqhtxs:[
        '99438b02c75adacc5ff3',
        'bb4118bfe3f8bba1dc6f',
        '0f0e233008caf1d3255a',
        'a197b71b7e95d025a4d4',
        '9a085d8501b84f0b72db',
        'bfbe0e175efe54d70352',
        '50bcf0d2878780523103',
        'e52fba2ea51a38fbb481',
        'a85c8afd55ad5680cb42',
        '3ee495b05c80f4c68b19',
        '19cb4a2b1f4d603f68ea',
        '51b1ec831cf7f2d56979',
        'db092caaae6356dcbb06',
        '2009e24b3548b56a27ad',
        '87416b6dd257359d548d',
        '8d9515fe6bf16042ffe8',
        '35d2e70205f6c64c8dad',
        'b2572768f925b411afa0',
        '33aadd6b46f9cc366cf3',
        '53aab0fe026b50287fa1',
        'a032aa8ec333dcb40b8f',
        '77bc959962a5536ac2be',
        'a1446ae88e2ae4e27991',
        '1d2552764c0165fcfacd',
        'ff1141132d8c28a58e80',
        '3da9c64746ec00ed37b3',
        '729c43fbf2a663fd13ba',
        '4a5efc7bf82bc743b02b',
        'bc76675bbba87b58158c',
        '8d3f7e75a4911106e484',
        '3d8f6762bd04f22ddb10',
        '0bc2712c469ecc80eb3d',
        '2049295abe39e76ad940',
        'f4885f9823bf96e6f93b',
        '8d9e8fd241aa1407700e',

      ],

      xqqqexs:[

        'f7acb67d16df1f00c560',
        'e8fe92a9fe526cd47efb',
        '3022de5b7c50f3e9fcae',
        '0ce43822d648f8383a25',
        'a23425abf02b7c01329b',
        '896ccfa3210aea06e220',
        '79a842dc42feb1baff6d',
        '334f563b77bb6daecc87',
        'e438e28063c33059b572',
        '20a19e102aa3b649c5dc',
        'ea5bba16a376d0a26c25',
        'd3ef049e483a03f400f4',
        '39b0b547e77aa2d14f26',
        'e1fc9819895ea6b4fec1',
        'd96c3098bce2128e1da6',
        '0c82f5d725e68a27d142',
        '1fd026e480da72a49018',
        '840b0c0023121c137627',
        'b6a15b51be2c1e478058',
        '161bb79a61094f89b3c8',
        'e5af9d3f70ae962fca14',
        '2c22f3f727df2f97d84e',
        'c4ed1c83b1694985af5f',
        'aab1638bac25661f452b',
        'c6f02de8aee4f9c799b0',
        '153859a08f98fd6649b7',
        '8aed5c8c08dc4a21a83f',
        '4b691eeaa174ec1928f2',
        '607ed3f8aa1ac8b65f50',
        'daa8a68d9880c24ed859',
        '707df5df3c4280ac657d',
        '7a432a6349b35903fcf2',
        'bb19150487d59d243fb3',
        '5c1d77bf9d475a33de7a',
        '643a13605980be2a8712',
        '40a6325e5404a1eb0d7d',
        '0a0bddb34d657060873d',
        '71dadecb6880327723db',
        '8e1530e849ba0ad7a4cd',
        'da484eacadab118f112b',
        'e5aa38ede14eab8e6b54',
        '697c1ba707f6fda428c8',
        '4363afe08e0944a3db94',
        '3dd5693261a03923ab98',
        '38f9f802b34dd133b801',
        'a733123ef81bd1c05ea2',
        '53623f68272579df764f',
        '3b636596fb0d37738cfe',
        'ea763186f1f58e149a38',
        '125fc1b7684cc0f6cf52',
        '7e2ad879ecabbabdb4a7',
        '9f484087408dc1b5458d',
        '1dd8673f655644db7340',

      ],
      hxz:[ '0ddcd91215f644bc9a63',
        'c4f4a1b84b42f3dc0dc1',
        '5f224ce2e55e0a342f78',
        'e07a18aa50a052186f14',
        '926b7cb993a6898f71c3',
        '5a2691650f8a33ea6840',
        '0f55b275f8b5d2899fb0',
        'a177a864fe663d4c35c6',
        'b7bc68b546132398bed6',
        '9fdebc95d69b0304b57c',
        'c3aa2e3da7b04805aee8',
        '9a1cb0cf26c72fd56a44',
        '67550d978e29e18beed1',
        '3498c64c74e306cbf54c',
        '84fb38f057052ce464dc',
        'af8109cba77836a2b796',
        '50fb96080e9a791c968a',
        '7163343563de84927706',
        'dc87d673815bced3ccaf',
        'e4a75fa3a8262b7b1a05',
        '664a84be28f800799381',
        '5264a4e5f6b74dacdc24',
        '8a60b5f55f66380425a2',
        '9ed2f47793e4bd8d2d8b',
        'cecdbf8293a84168f539',
        '85974b1df281ae4882aa',
        '720969e997bbd86491dd',
        'f962103e4a458979d13b',
        'db083162e379268f1a4e',
        'fb8d8b68eafc9e701799',

      ],
      ch:[      'ef2214f7c21630c1f221',
        '35da84ffbad44e062ba8',
        'cd2923ae58899db9b72c',
        'e826b8253ba380bc098e',
        'a15a24e2b2b79cff6c45',
        'ab642d3f7778f8914d60',
        '5e73ea1eb16997931ea3',
        'a1b8aa787ce29f19a4c6',
        'b2df04590dd1ebf97679',
        '044b52b51c33e5959927',
        'dc0427febd611518c6ef',
        'ce7a4035c02dd65a3ea5',
        '72fa029edb6a64ab291f',
        '8adc6e6859144aece0e7',
        '8542593d49e6683235ae',
        '0d6a9b263d356258f3ea',
        '61f6e9e02a6e16119063',
        '006c26538ff0559e8bef',
        '959930e05f2c604f47d2',
        '795bdb40273b9f20c7a2',
        '2af11e06b8b7dc7038d0',
        '0257ea55ab44c5fe27fc',
        '4bad35c2fecdca4223bf',
        'a1c09cb15535df799b72',
        '05affa995b6304d87d0d',
        'b5056e60df7f17592485',
        '59616ff26dfac1d8251d',
        'b15de5af1324a2ac17a0',
        'a5f4fc5eaa1e8ad14f1a',],
      wh:['ea16526d24ba3f178013',
        'a6b87ae122696784c0ae',
        '13edc6df50c833a470c2',
        '1847dabe9b01d469bb3c',
        '8dbcd2f2d8b4471f54d0',
        'e95170cf7d7aa00a8905',
        '1796a796c35cea089e23',
        'c7eb4f852cc4f92e6524',
        'ba2115dfb75056948fc6',
        '3517a81bc184b2f81d5e',
        'dee9f6c0a07cda00c04d',
        '2a30aa56486de6354f42',
        '188311d2d3e779682e41',
        'ded8629ca5e7537a58d7',
        '9c0f4396a5b63645f004',
        'f00b96e97df5da5c0ccd',
        '293d9dc68c39b8bf9aa7',
        '46c9389f4bad1a34b074',
        'c0da369bc4bd64f336de',
        '3c66dd88f6664eb00716',
        'cd11ad3f8b2e95ec951a',
        '3a5cfa90a51c6b937cbf',
        '27719d627d8c6d9f8e31',
        'fb2069a2e360d38b5545',
        'f317cd72f84874b0bbc0',
        'edb56d19f4d675e942e5',
        'da573104aa469a1c475b',
        'fce8c6c7582a79344ade',
        '290f757e9bb92d69bcd6',
        '97d817968f2c7ff4ca17',
        '9a6362fe7a6f98551447',

      ],



      klks:[
        '497665e4df0af7581c8d',
        'de467dba5d48fe983387',
        '6a111f6240ecf0c571ee',
        'dd2be65686d413eb2945',
        'c78f95362dd7f30f7d89',
        '7ec25c61788ea075f8c6',
        'ccc04316d353fdf4d7ac',
        '33c81cac7e81da8eb9c6',
        '8cae2011454853a15ccd',
        '8fbff87edded1120e1ea',
        'e835064dd0f3124677f9',
        'de0a3ae55029a60342e0',
        'f89c5cc8f403311135ac',
        '2906b8e56c0a87830555',
        '98dd81589a0fef9b03fd',
        '783716053f5e842d36ad',
        'c0240c598212ce85b8cd',
        'fa635b5149a2733decd2',
        '93a6e7bd0a1b8bee0af3',
        'bcd90f1c488e4c444fbd',
        'aac1e65dbaabf8fde2f6',
        'a3ba70dd6bd0c9e64cb4',
        'a4cb40a06ab9cdefd338',
        'e8b725f7b868a8286a5e',
        '57d12efd1ad7a63c7b6f',
        'ae5db0be1e7cc8589d89',
        '660d9634150eac11acf6',
        'f879800111dcb50d8447',
        'ed329332575af74a8e58',
        'ff309b70b1b46a913f35',
        '6bbb854f8a0c85ac19d8',
        'f3d0ba47af200db69b3a',
        '912107cb143a453209eb',
        '619d2d90d1b4f1f6bccc',
        '2a21bcd462c40854bbd0',
        'e90aea90702258cdb9ac',
        '7aad81317821b399e799',
        'c562fa93f9ef72b93d5e',
        '1114c181239c313a6a15',
        'ca691391da48b11ba280',
        '665b697b2c424d32b40d',
        'd12faf64d358b8ac8775',
        '4c51e65dd5d978ae154c',
        'c0b324d83bf2a3de704b',
        'f0ad9d3a4bacdf660552',
        '1ebe940eea8d8d1f21f2',
        'fa7f450141e33d26dc1f',
        'a693491239d8f5e9fe1e',
        'ebaab3b7791fe216e9ed',
        'ceaa585fc486e271d734',
        '0f90bc81d11c99a3d2e4',
        '227f865017a363d8c7de',
        'f05e729f708bf6413987',
        '22b7df987018d2044b40',
        'c58508d68d20f59caebc',
        'b85f69ef2bbd1f217fd4',
        '46312369ce569c109b20',
        '78bac7e5827d308b2b9b',
        '24a91cbd80461f38ec78',
        '695e7ceaea82369aeaa8',
        '13ef49618ce600025102',
        '4b819ce558aeb19d8295',
        'a1979c5f89a0a740bf04',
        '899dbca7dc2f53be1c43',
        '97a4a3e1e03d85e8eca4',
        '66cb3347584b45013c5e',
        '0dd00e3c2b22638553bd',
        '98b44ec43e8f63fca340',
        '41801325a9d6a1edadc8',
        '11ee7bc8e8794d61fbb5',
        '8ee977fdf662e669519f',
        '6ee02a3e48189fb077f5',
        'a47f56c782b1e0c76a3a',
        '3ff537e2e0cf1f426d0a',
        '2ecf98e92d4ae02501be',
        'd1dced7ebf85ba46d5f9',
        '567bdd59a54b7004a357',
        'e110d1336de13a333c2a',
        '0c4515d628a453e246b4',
        '39d0e578c57f0db99ee1',
        'c4b5192ee9b98c4d6c35',
        '03702a1961678972f86f',
        '9599c666b4cf0eed8062',
        'ed8b97c04aaa14980495',
        '9b1aba618701b83ee89b',
        '4a3fb74f5a3170e64a60',
        '65e3bb048b21e88fbb41',
        'bf355a1551748f2b3715',
        '697ada72bb527e0ccd27',
        '409c3f2ccab7a08fdc3d',
        'ad45bc0c67c442696975',
        '499fd20bb9f548982c00',
        '3d31761693d2520e7c23',
        'df098dee1144db7e69cd',
        '1c0ab3980c2f23e6c12b',
        'f5e62efcafe8488169c4',
        '0c3a90da7da952ee4667',
        '7f01fb56e417516ea9f8',
        '0990918065345220f6fe',
        'cb34b12e6d4e6ff32305',
        '745f290121090bdd3c07',
        '46ccbf33b1b2784841ca',
        'f66404ef8aa4aae0ce69',
        '5e08b545303f7c753ffd',


      ],
      klkstoken:['96583eebdfe6abc8d6d7f60770a419d6ce850eecb4ddd94de95a0915851c7cb2'],
      ssxs:[
        '5a2691650f8a33ea6840',
        '2af11e06b8b7dc7038d0',
        'ab642d3f7778f8914d60',
        '44bae8e823b0281491f8',
        'da573104aa469a1c475b',
        '50fb96080e9a791c968a',
        '2b01f55610d54835c345',
        'fb8d8b68eafc9e701799',
        'ba2115dfb75056948fc6',
        '46c9389f4bad1a34b074',
        'c7eb4f852cc4f92e6524',
        'a15a24e2b2b79cff6c45',
        '5264a4e5f6b74dacdc24',
        '85974b1df281ae4882aa',
        '0d6a9b263d356258f3ea',
        '1796a796c35cea089e23',
        '9fdebc95d69b0304b57c',
        '9a1cb0cf26c72fd56a44',
        '664a84be28f800799381',
        'e4a75fa3a8262b7b1a05',
        'b7bc68b546132398bed6',
        'a177a864fe663d4c35c6',
        '3498c64c74e306cbf54c',
        '3517a81bc184b2f81d5e',
        '293d9dc68c39b8bf9aa7',
        'db083162e379268f1a4e',
        'e07a18aa50a052186f14',
        'ebfdcffa190afa272851',
        'cf2797562423b1801502',
        '2a30aa56486de6354f42',
        '5f224ce2e55e0a342f78',
        '67550d978e29e18beed1',
        '9c0f4396a5b63645f004',
        'dc87d673815bced3ccaf',
        'cecdbf8293a84168f539',
        '7163343563de84927706',
        'af8109cba77836a2b796',
        '8a60b5f55f66380425a2',
        '0f55b275f8b5d2899fb0',
        '926b7cb993a6898f71c3',
        'c4f4a1b84b42f3dc0dc1',
        'c3aa2e3da7b04805aee8',


      ],
      ssxstoken:['c76459da2362e48013633cb91913ba3c38e1527e7ef55894836704101232321d','99ad52c9f6ffc7df551d6996d94d8717d3aaba4cd4ba7c0552744fb861709fe9','07ee5b503590c45232d1ae2ea4731366d07034d78458d38ae5cbed17b2f51fbc'],
      xiaobai:['6dc95a3defa9966711cd4722521bd7c9cf0d4ea90655e8f07bdbf2f50a263955','e28b540298648bd9b4c4f6c7c6ad50f1736c62a9cede45f64658b09ac33946eb','34e86c1ff5d892d596ee71e5af2127aa44e8abbd1dd2d15b62007263c14d84a1'],
      dzff:['5755c2339d285c377309','db7900d42287b0134ae3',
        '1474883092318b39dd6e',
        '73a8b62d777bffc0f68c',
        '52319f9cd43c6cc038f9',
        'd7ff6399d9b10430017b',
        '6a4a102b4bae31705803',
        'eb0efeedd552aacfd981',
        'cf99c4d1d08f5f3f46a8',
        '0a4275d5d1537bf3c2f1',
        '0ed0a2e0889c4b8a0b28',
        'f07a2dd9b08a42c82280',
        'e6880345901c4148f63d',
        'b0d69c031583da4ccbd0',
        '5f239d3c72abfe614297',
        '2721539cf02a3e0b8e54',
        '4f8d51b0b59ba5c3b712',
        '046d6b6a22a041695722',
        '09f0004fa2e7e5410c29',
        '911db75d802bb48058c7',
        'f74741bc5bf00b7f4c6b',
        '921467357f0024e8a21a',
        '9b41815066836051cb98',
        'a2d6c3799e6cdd6659af',
        'd037e583538259f63019',
        '0d5dedc6fa0c6b2b4d55',
        'a7dad8d273316fe4c553',
        '99524ae1731990f08c56',
        '521c66b6c66424f8cc33',
        '8f6b8507343bc53b27b6',
        '900013b57ee990213bc6',
        'fc1027e56d967f876b0d',
        '86e46f307bb5544f1ad1',
        '18ae830f3c361f002a6e',
        'cba8a7b0209a7ee56a80',
        'c0ab37db1ead60308db3',
        'bf46faf40a1d4dd8d45a',
        '7ffd7c7bae9e6d8e1df7',
        'e1178c666ce097f0a8e0',
        '45e25d5dc950099dbc16',
      ],
      // mrqy:['7184819045e707d42474','7e1a92bee5d28f0ebd01'],
      mrqy:[
        'b48137cb62870d885265',
        '2ae29945877a5c9a4dc7',
        '2e14d9caaa79a7288945',
        '608cfd23c4899ef21951',
        'def6f567ffb8d43e6cc7',
        '3838db0ef055dcef2d73',
        '5241b2f39d22296ad909',
        '0f4ed863345486fd6566',
        '9b258bcd475d37f2bc17',
        '4304bd9984a383abf7f1',
        'db0492433fd6e9c3ab44',
        '0efb4a6665e5f45d4221',
        'e26f2b1791468c46bef3',
        'a89dcd56fd5db0f5b616',
        '09fd6c45513dce56de4d',
        '4fff6d3089e879810863',
        '9e7cdcd1a5f59d755a56',
        'a21a4926283015f09cc9',
        '03a1e942d33c5947fd8b',
        'ae561695e426daa8aa50',
        'ae42092f88874649a285',
        '54461d32d322ac718a48',
        'dd631409284b309aedef',
        '16ed37dadd53b82072c0',
        '926983ed6481b7b856a8',
        '5fccb9278cb8ab132963',
        '0268bde8b59d63c47a6d',
        '4c323980948ad8f347dd',
        '173f1d77ce7a00833631',
        '1fea626e7d2c50c5a3a2',
        '041228e13e4a0ae34c29',
        'ba0b3afcac862d1a818f',
        '64ddf7a454cb8646a61d',
        '38c00dafbf31b9ceaef6',
        'd73bfec22f9b6f588181',
        'eccc4be71b2f5b7cdd8b',
        '8b4628c4bddb0d3fd7f3',
        '6ff3b3c20faaeeece736',
        'd3035a2bbce5af457b68',
        '2cf37001ae2ab7bd7644',
        '6c33c615b391673106b1',
        '28e4245c0c5d9ec46c14',
        'd02e34c3e915da12e878',
        '23cbcc552564ac0b32e1',
        'cc4d431364a6dc33854f',
        '6f5f2eab7971aa0a6b5b',
        'b02c9d7a802ecb286e43',
        'f0106beaddeff66eac82',
        'b6e3d2ad3d1065dedc23',
        '9d3bb1239409b07fb8dc',
        '48c03389915c645dc0d0',
        '482942cd2c0eb32676a0',
        '22f5db736b71f3f966bf',
        'eb10496395bfb874cade',
        '2828fb55e8cff699699d',
        '57127ea07e1c26419555',
        'b46788c36767c8388b32',
        '6a95628ac5df0d0a182b',
        'b4569ad2007f705c830c',
        '29f714073bd8c2547262',
        '8f8366486ba30532464e',
        'a2741cb1875f4b93680d',
        '5b2ddc744a1749a3a07f',
        'c4eca3e6db65646e2fe7',
        '85005d21d7a2a52434b7',
        '7311a8570ab5f1779dfe',
        '6a7cd85a1aadd8946415',
        '9d1247677840f29331f1',
        'd4978e385ed2d2048fc6',
        '803a0fe8178d01b0b8a1',
        '30f5a74dcd9ca084e4a6',
        '093267d0617e17fe8d45',
        '7e1a92bee5d28f0ebd01',
        '47ca49d978b2c851a7bf',
        '96de265587f5c02ee0f0',
        'f7592977fc08341412e4',
        '374b2fa987a5466a81e6',
        '4b178e3ad44c1a3e3a7b',
        '680675e70cc8fd05a383',
        '56367884530b153adbdc',
        'bb79ada76ed3928b4fba',
        '8d1915fc098712ade5fc',
        '57fcb17abeb2b48d916a',
        '1abffe93a814fe02c9c0',
        '65c80c5a447afe18f23a',
        'c9dadf278b775ea2bf15',
        'c371e29b87cc483cbae3',
        'be07e6cb7ecf711c92a2',
        '7248a6793ccf7babd791',
        '51e1f78ca8272e9e53b4',
        '2b1ad58dc00478bab78f',
        'ea27bad813fc0ecb59c5',
        'c947016142e49180b587',
        '00545aa6a10ac8260571',
        '2fe42740c3fedcaf3083',
        '795add4b50369c7cd451',
        '8c65b4fbad0f4b59afc2',
        'e4e8f626f941e3e0afda',
        'ba1bd0de861517c8c14e',
        '8526a902031077e20b64',
        'afbba1d599de5a1beb44',
        '4601bb3e7fd68afe6916',
        '1fe6142d0b5209e968e5',
        'bce3338c8269b171686b',
        'f6c59b8dd448e662d28d',
        '39d78129b5e402a6168c',
        '8d4e99969a8a9235b432',
        'ade65a17cba3d7cd52f9',
        '7313e88ffcf7153ba33c',
        'f68165e50f5c81d290ce',
        '4d6b5f0f9180e43ea284',
        '3ed29322ec19eddd84a5',
        'a6b53f307734ca6ceb08',
        'b26029813915c6b2b501',
        'ed816a35ace32fa6c180',
        '99b135e185f8c744e079',
        'ea7979e37c54f99bc66d',
        '5ffa264ffbbfa725d30b',
        '7aaf7f546366a23436f1',
        'e855dcf927d4b1999c72',
        '5b1542c0d33fb24be6fb',
        '6add1f28c367ec786e83',
        'ec6fbe3f03c756cd9caf',
        '5bd11b22b6eb9615e5a8',
        '99c7ede18c671f7f1ce0',
        '7184819045e707d42474',
        '01df04d1c86a03a408bd',
        '82afbe16a5febc2f94a1',
        'edb6b0dadb7fa5582505',
        'ba7db98293f76965b053',
        '2feacd2ec1cc3665f24d',
        'f0772a953aabe2ecb039',
        '3a7724f7232fc1dc78a1',
        'e89af6e602a966596878',
        '0e035e5cc02d670c8ad8',
        'a2a1a3a07b3cdef3be7d',
        '9e0eeb0cfdb5c843fa10',
        'b79ec4d6c4c186e2f5a2',
        '9d247cef08b82407e7cf',
        '727a87d20eb346e0f488',
        '71aca1890e8ff242bc02',
        '6596655fc11594c811cc',
        'db81b21357fd08c39ea8',
        '64daf92c52b1a9ed8e3f',
        '25c6f55b21a1228b4780',
        '9c7eac12437ad3962419',
        '8338978946fb42b8b6b2',
        'ad83b3d2e45c37b3eb3a',
        '06fe089672423f124479',
        '841af812aafde46707dc'

      ],


      //
      // qexs:[
      //
      //   '26e0a5da7501231e2e89',
      //
      // ],


      zjsktoken:['bf582040fb08dbe13e7c57d7e2e09910ce704ddcc25ac4d70ba437f43db16adb'],
      zjsk:[
        '97f80e9b6a14761a5ef4',
        'cd7280a61a69e67bc91d',
        'be9b303abc9ab611ca64',
        'adc678a6bfaf8f384f17',
        '2740faec1a5374e8d02f',
        '90e62cf5ca749954f9d3',
        '1d9ea69400f2368efbba',
        'b3118182bdaeaa4de1e3',
        '5a63a861eedddb78eb40',
        '46e299db4c76ef4d4f35',
        'e111a2ca4f07d5101959',
        'c8d2fd9cb7986946e9d9',
        '2bdd2033b5f2ed845f48',
        '3a191e7a2a5ac0e3ae4a',
        'f2d5a09cf1baba9a1df8',
        '9661ba9c8c6dc8fee7b9',
        'b2d5bdc908eeb70d746d',
        '81d0cd40235867c35ddd',
        '2dc696c5860c61f899c6',


      ],

      //  qexs:['a5a031d51f457068eee5'],
      qexs:['a500516c4dedc104354e',
        '2ec2c267587f3a417f42',
        '882dc926bad26199f1be',
        'ff0455b532f7e3604b92',
        '4dd78dbbcfa70a29d791',
        '64d6869a75c255b675de',
        'eadc8c77bab5bce63e51',
        '59f8612455434c35b9c0',
        '9ba277102958e74cd494',
        '76c1a0505e1acea7b091',
        'd98f645603d4c373d0f7',
        '324df49bf4f2a31c1e13',
        '89c52b4323ec4b0fe5c3',
        '0c82f5d725e68a27d142',
        '8049bd0dc2c72b156f91',
        '4023dc0c91b726d27bbf',
        'e5af9d3f70ae962fca14',
        '0ffe48928fba40545a96',
        '9237d11638c80764622e',
        '473be97304114b4bed9a',
        '707df5df3c4280ac657d',
        '07a5a4719d384779daa8',
        '0041c11fda3668f5628a',
        '4c883f127cfa7838b227',
        '1735e85c497cbcd97d25',
        '0bbcc7632022779f3788',
        '9162cb84dc5d2166f125',
        'e2b087ac0f3956252299',
        '5ee1539fe6a76e03c83a',
        '3620098d569ff8a6eb56',
        'e546100c2fa38d657aea',
        '4e0bc76db14db575fd4e',
        '221a3eb1004ba86b060d',
        'd30578b26b87f05b5213',
        '125fc1b7684cc0f6cf52',
        '7e2ad879ecabbabdb4a7',
        '6addafbeb96d4d8bf806',
        '17f7264a838f88940edb',
        '3c89f3479a3eac95d84b',
        '9f484087408dc1b5458d',
        'd75836ffe2f0cde257d4',
        '1dd8673f655644db7340',
        '18fdeeb6f18acbca5bc7',
        'b159032947e776a4fd31',
        'c47b60f2abdaedcfb5a8',
        '08f6032e725bbf6e3d86',
        '6bc3e7ded7a853323a84',
        'df26de728a0683ceadeb',
        '634001db32a4a5835292',
        '309ac9c07d58fd2c3ce0',
        '331d77af0be0ff7e4865',
        '02d66b7f13bb75d6e4da',
        '7237777d7d181602f9a5',
        'c8083fa9aad1f3d169c8',
        '669d9bef06af4afc5adb',
        '82192739381287e439e0',
        'bd8411783cf6b732272d',
        '770f21f583aafa98bd9a',
        '3826d6c98a89caaf67e6',
        'a73fe59b5465eff8177d',
        'af02b4d791d5640006a9',
        'f7acb67d16df1f00c560',
        '0d8bd1d18d52f7794b5b',
        'c2d395a5a619b407f16d',
        'e73654b2ba7557ed6d00',
        '696b44fa1fa825e71669',
        'ed91321adeaf58820e30',
        '5b8a588ecbd6de59589d',
        'c9a399e72f1f989f5160',
        'de2e560b310ef7176ec',
        'e1a73c3232bd362efeca',
        'b71925f13250881143ce',
        '0b59cc5d359a20c68cfe',
        '5a11b082c053563ad29e',
        'ef25324f96bd44540c21',
        'a26eb0da5589d6598953',
        '21078041beef4b0ed021',
        '6943ca3b8808d20f992b',
        '51c330e5d29e69500b41',
        '8f239d8dc7742aa7f71e',
        'dfa8ee56f4e64b63e5af',
        '8ca2492fc204c70e24e1',
        '00f74435002006261fda',
        '405f14fcd2e4cde955d9',
        '315063d0c54b45dd8993',
        '36e163923792b8932521',
        '66dd11288b50ab32f2bc',
        'c9bb9fd33abe4401669b',
        'e257849f7bb1c8673b8a',
        'e4dae19aa7f0bd8ef35c',
        'f2b0b3d92fa460b8dcb3',
        '465d77d7853e2b7f3e44',
        'f8654cb71f9c9cd7f1d3',
        '21993094b7feb33fbd10',
        '9c9fe42897454bc99ecf',
        'ca9c3555f86d5eea8b4e',
        '525ed614abef348fc80b',
        '1cfb23e4e29d57bdaf4e',
        '6e978d6f4173b046ed99',
        'e20c882f7f4063da71e5',
        '9742ff6412d449803446',
        '071fcaecbef0e41d58f3',
        '7353cccbfe556781a93e',
        '90cc138fa9c44d6271a6',
        'a8df41b46ba8cc7421f1',
        'e5800f3878df4e8960cc',
        '5bae27401e3b3da7af2c',
        '05ca561ebd2c9bd9952b',
        'e8fe92a9fe526cd47efb',
        '4a5acc172948ce6f632e',
        'e9fbe8a7704fb7a082a1',
        '7db0cf3a6039aefb8173',
        '26e0a5da7501231e2e89',
        'c4a92451a1c023f45194',
        '6359a30d43b5a49f59c9',
        '5c619c053126588c19ca',
        'd2a9ef3ad5b0f3251e22',
        'f886857fcc29d39deed2',
        '4ae8730fb791ed9d759d',
        '707d53a16d196aab523c',
        'e2495f7e7cc8072f23ae',
        '4ea728b028228672c255',
        'c9dfa13500fb7879db43',
        '87b30e5766e1a8d1547b',
        '6c8b107b646b30b7d9f4',
        'd228251deb6f37cfbc62',
        'cbab3665d6876e655be7',
        '3022de5b7c50f3e9fcae',
        'c7073fbdce11a30a5ab4',
        '9ed2772b55ddff8d1cca',
        '0df55f53dbdc08a2070b',
        '7f84befb9b65c0a6cfeb',
        '411f4b14e9fef209c251',
        '063f2344500dd4e1b6c4',
        '3d91a5f61a141477f483',
        '986ac279c7a7442ef56a',
        '0ce43822d648f8383a25',
        '160921b0415e3ed000e2',
        'a23425abf02b7c01329b',
        '4ed4b7b52f227665184f',
        '9db2bfab75bd1184f597',
        '54a5041e5b151bed8ff7',
        '428e86ec8518698eeac0',
        '644c52551d918c465a63',
        '357990155988fccb1af4',
        'f62913ea83d18cbc6626',
        'f931d61c532edbd61071',
        'ecf087dfedf2a7531ca1',
        '99240604ae593f488e65',
        'f5da948b5d187c0c797a',
        '21e195d14b8eeb13a007',
        'd17ec3e9239599d5a075',
        '31170d5fb97efdc65352',
        '319db7ff6be0bc1d8d2e',
        '157fc6ea364d639f3721',
        'ea7ed5b2f7ff0e58a570',
        '661aa4f943e68248098b',
        '0144a710b6713c40e5a8',
        '896ccfa3210aea06e220',
        '91583d5f2c6eabba999d',
        '8826bbcd0c8cf11e0e68',
        'df978e6e3f7e401649f6',
        '923d9b13aaf89d5a9f13',
        'd9395b795a94d4732334',
        'a8482622735b90d70193',
        '05d89d02755e4d183742',
        '92e08d579fb6102613cd',
        '78a00a7f3ea444931447',
        '5db23ca267b860ebd20a',
        'f838fc2f0f15d7d4a02b',
        '2a3c5ae6c919f70f628c',
        'ed92dfd4f684c59447bc',
        'cadd25e593da2c1ccb18',
        '3c482a552d559ccde61c',
        '8c54910039b746dde372',
        'd56c006d5cf204c98ac2',
        'abb0d916f6ef090cae57',
        '26e0a5da7501231e2e89',
        '622a377cef2b2f759824',
        'f39ce70b5d4920d773ee',
        'cb21aa0336f8f208d186',
        '8e8c965ec59efb60c3f1',
        '56100efc9d755688298f',
        'c4cb91d3e71cf3137169',
        '3bc201bbd51449847f3d',
        '7e8350974bb3ada481b2',
        'de2e560b310ef7176ecf',
        '36b4944dd1cc8358791a',
        '413b1d7189ed9d809700',
        '00e12b93e5938e30c1ac',
        '3584707155201ad21b61',
        '6db24f8385902f2f6679',
        'e365bac36811885c3e24',
        '4f019b58fade8e0c941d',
        '3d97891284c8b0889754',
        '564a3134dc7236a390a0',
        'ed06728e22810fd635cb',
        '58e4417e5eb38879e3e8',
        '95d24955f7a565eca867',
        'efa19d2e48bd2f606d64',
        'b68119151b6044290b88',
        '38fa1cfd1685382fbc4a',
        '87b2c46ef8685c60a99b',
        '13ce2b4b8d230c05f2e5',
        '6eb0560205b5104481df',
        '8c234319900618f8d84d',
        '140a56ac5f80a34c6997',
        '8d872d0b26caa3604ff2',
        'b892268c991a321a6dee',
        'b7f66f659167e279d499',
        '79a842dc42feb1baff6d',
        '8e4a91181587c113a119',
        '334f563b77bb6daecc87',
        '520d5424614ad3f60478',
        'a9954d5b7de8344b071c',
        'e438e28063c33059b572',
        '10d08ce9a263453a1562',
        'aed5f4e5289f876a148f',
        '8dc9d96b6f8acd87ee1a',
        '68d1e20caa8e73074406',
        '293af1b0d3142f3c976f',
        'e0eaa33c58b26892292f',
        '0c419224a3b3a16a7414',
        '9719ea3698efe6763dd4',
        'a2686608ecb8757b0353',
        '57720072030c3c8750b3',
        '6c5551298624fd3d13c4',
        '717f17949196363528f6',
        '5f8a2535eb83cad9f290',
        'cac9d4e873fc65c805f5',
        '6e88744adee791df553e',
        '6ff012634b353a82ec5b',
        'ac34f2f825dd34a475c3',
        '4ad8a45e884fc6d97d9e',
        '9329cd25fa01b5b6cf43',
        '29b08cb51de74c8371fd',
        'aa9cf5e1a124c6e79657',
        '59bdd1082210ec2bfa3e',
        '20a19e102aa3b649c5dc',
        'ea5bba16a376d0a26c25',
        'f9b3b096f0ec32811f14',
        'a82234b25689b4a6a3ea',
        '20a9e0c4ac0877f79025',
        'd3ef049e483a03f400f4',
        '3ebd69aae73237df6939',
        'ebbac63577b608eac734',
        'ff39dc0550c82bfd667f',
        'd694a7b207142fbba59f',
        'c02eb4879638038a9c07',
        '39b0b547e77aa2d14f26',
        'e1fc9819895ea6b4fec1',
        '297fc631ff7c3012e083',
        'f48d0562d3be092164df',
        '23670440ed5d1ce3cdfa',
        'd96c3098bce2128e1da6',
        'b07bb2ae482d968f7753',
        '3bfcf19853574dd75e28',
        '80381622bef4ac7428e0',
        'd8df7bad8f8375be852b',
        '1335145ea7e55356690c',
        'c33b94f69e021a2f7846',
        'bfdcc51465ccc3a1c981',
        '6184c52ddd467461a3e6',
        'e7ffb955e8d6a3d9cd36',


        'd93273f9da6cdd68278b',

        '962953545c8f8a0d8a0e',

        '1f9c8b0236e4d0a24c3d',

        '20a84b3837fa10f90ffb',

        '81849140d896b6b352a5',

        '3c3d592a2c32f5af5fa1',

        '03fbddce6852ef76cd64',

        '883f1f5ccc55c2e5cbd7',

        'fcaed9ee3a7c3ec8f060',

        '5ce753a0d822e3499f44',

        '42f132970dd1d100e3a7',

        '3e177ddfa94f54a8cbd8',

        'b559f7d714e24e619f0f',

        '3a92c594d79d68149901',

        '9672c89ef0a29c0111eb',

        '171acd5fc73fbcc4ccf1',

        'd0df2aa15426ba0c7c24',

        'f46b63ef7f99702b36f1',

        '21a959eed0b0389bb9ee',

        '0ad6f2d155ef7a8bc573',

        '8d3b5970490d4f284f15',

        '161cbf4e9b55624ff6f6',

        '30734e85f79c8e48891d',

        '70ac0be24a7a05f502f4',
        'f7a29656c20c3d924ca7',

        'de54a02aa8ecf6ed135e',

        '2f183736794b488d65d2',

        'e62a8fd32499d8db94e2',

        'b37be0e4153550e6a678',

        'f74c9ceac752906ad815',

        '93a346785fbccc60d894',

        'e7624b4c68ca842b2c18',

        'd56417f5c8995722e911',

        '95cf4b704098b38532a1',

        '14c1bc6bdae860f357ea',

        '771847b4285ff489f33c',

        '1974ac1868c67a6ad4bb',

        '381d6c0b7847f97c06ea',

        '9f93c699c6f89f987bb7',

        '2c389d906aebb5813af2',

        'd6c9b30b2049975fc502',

        'fd3a2b913e7e98fde199',

        '835b93662b6c3a16f27b',


        '70c46ae90a78de8ee1c5',

        '3028177f3c8d65390ac4',

        '3c51e330ee1ea9c2f823',

        '0477c476fa2bac145451',

        '9b24ae0bc222613dbea3',

        '6ddbb842830a469b1e38',

        '9c9b6fae2d1437d30ea0',

        'f84ba4905a704bec5b3f',

        'eb4011be628739ff437c',

        '26787fdd1b6af16bf0ee',

        '59b1340935293933413f',

        '61b5d64922e64f7cc3fd',

        'c2f40ff5327db472d8ef',

        '707dd95ce2bee3e2c375',

        'bf6302cf0cd701674a30',

        '78a8e75b044f521e0cca',

        '1fd026e480da72a49018',

        '47bbb1adcdc7c59bb2c8',

        'a711448f57066da6cd00',

        '70f9dcd05753c28e4fe5',

        '26b8ae398e9a79888ccd',

        '81c58b560806b47b768a',

        'b0bd30adfc06f75de19f',

        'e0cc053773e469e064fc',

        '840b0c0023121c137627',

        '736a2ddd4cc08ec3ec15',

        '88fcdb797e333a068ade',

        'bd0c35580eb67831b9bb',

        'b6a15b51be2c1e478058',

        '161bb79a61094f89b3c8',

        'd14d30eb603141f58233',

        'ca73d080b0777808969c',

        'ab4bae92e6f0a2d678a8',

        'c3f47bbd9c11f7db0946',

        '7116283a4df2364d6adf',

        'ea89655906ce3e181965',

        'a4ff3a43553873496878',

        'b28b3906a2b7b1bdce2a',

        '2c22f3f727df2f97d84e',

        'dfd95be50c1798bf2937',

        'c4ed1c83b1694985af5f',

        '5f6a864c3a7e30327fe9',

        '4dd61dcfda4dd4e0fb96',

        '6505874b07d4c7dde15f',

        '9387f4b502966624ab12',

        '37bf13f47a13a4c6f8ac',

        '7025dfc1fcccd44d0e81',

        'c5a230679cab6b9b8c77',

        '529917862cf03bd2ed0b',

        '01b1c9732e74619f1faa',

        '34263e138748a8522e58',

        '0d2f7b27a1494a8f05d0',

        '3568b253358f2f47714e',

        'b92510de4f44db067626',

        'a1ac60558323d7ba4401',

        'e5d2a71e92eb83ae26f6',

        '9ae4af229a2a4a7affb2',

        '306e7b994e576bef8d32',

        'd2611ce4f115cd10175d',

        'f8d4b2523468ce11926b',

        '9eea89fe6bf246b8a281',

        '7c45007dac85e8a2d014',

        'e3ab8b00ed3071b4855e',

        '0f57b5c87e00370da6f8',

        '492389959a35250347eb',

        '6c38aa8a29c8e44153f4',

        '5d8004979fd763a66a8f',

        'd7bfd15c50a005d346a2',

        'fef044669c4a644d64f7',

        '6ac061cddca56c2d4090',

        'c3c30aa06d716c4c22db',

        'f0754106e8462512bee9',

        'e1e16779a8080fc8a88e',

        'd1b8abf23f86e512315b',

        '8228eed71eb6b8cb1fdc',

        'f5fceb194af962e17b4c',

        '65d8ede69706ba8a7139',

        '0d129ffb7383e182110d',

        '8d29bc59f257b46c1475',

        'd04e069b2fc09963c12b',

        '675059740252ae75dfaa',

        '90faf7ede59e423fc688',

        '005f1c1328b3e43345a4',

        '3dabe29cfbdcc13bd7dd',

        'bc61fc1fe4d0539a7ef3',

        'a509a67c0d65555828d5',

        'adff3458df0960735ee8',

        'f67cdd77c60dcc4bf091',

        '133be5d52b6d6b3fb6dc',

        'a233d259a4bfabc54612',

        '179c679efbd8c48dff73',

        'f676d925a39a6eb80469',

        '8f4394ccda6a6e5ce670',

        '603cca933896f0c52541',

        '4d8aa7825545a2ae26be',

        'b02870be0f22229cd13f',


        '1a6114a91b779f74801c',

        '44247fcf90f63775972c',

        'aab1638bac25661f452b',

        '349abc31a7e4e4069be2',

        'c6f02de8aee4f9c799b0',

        '153859a08f98fd6649b7',

        '8aed5c8c08dc4a21a83f',

        '4b691eeaa174ec1928f2',

        '607ed3f8aa1ac8b65f50',

        'daa8a68d9880c24ed859',

        'f1b6a08d7f62dbe8991d',

        '9e27a9c9731ac63b5319',

        '9be5a40578c2316ab173',

        '48ec18a6850240e697ac',

        '150a61fc9dd19476b6c6',

        '9192076dcdeaed0875f7',

        'cdb8497fd525c84fdbc6',

        '494c3d0ff04a66c8f306',

        'eb1f7e957cc483588859',

        '4a918597aa94f6f427f6',

        '266105fa6f66e6042573',

        '3e34981d0621588aef4e',

        'a588833d5fd975a81654',

        '5670cdc442562acb8892',

        '17ebb64b2098fd7b3cae',

        'c4d5120ad13ee75eecc5',

        '3832bc2ece44bc972c99',

        '49a1f3a9bb4794a9c53b',

        '67887ec55fb9eb34dbb4',

        '101fd8d47c8e5cae4604',

        '2531dcd119cc0571e074',

        'c7a368c7aaa91221f53e',

        '70c3e159766973f03a01',

        '10912070b965c7e34672',

        '0473037934b8b427b0dc',

        'c9b6a987e78943661027',

        '40ed43029ba34672a5e8',

        '44471a691cf65a9d9ad4',

        '1e8e503034142f5da00e',

        'c662a5e80cfefaa57609',

        'bc3e995505c75cc54467',

        'fd2dc518376cd563f4f1',

        'cf68d4d3f2077cb67df2',

        '71832b1baf9b09729632',

        'b37c62a126573cf14631',

        'bf873a15d799c7b1b067',

        '7a432a6349b35903fcf2',

        'bb19150487d59d243fb3',

        '5c1d77bf9d475a33de7a',

        '439b7bb18563d921f3b2',

        '643a13605980be2a8712',


        '40a6325e5404a1eb0d7d',

        '0a0bddb34d657060873d',
        '2a13a76aec5f7eb03bd1',

        '71dadecb6880327723db',

        '8e1530e849ba0ad7a4cd',

        'da484eacadab118f112b',

        'e5aa38ede14eab8e6b54',

        '697c1ba707f6fda428c8',

        '4363afe08e0944a3db94',

        '3dd5693261a03923ab98',

        '6752faec09464b0288f4',

        '0081e65080162703cfef',

        '892974608821f3612be0',

        '61eda6a9f973e571a9cb',

        '63aff4f8b8f2667b1c7c',

        '91d6dd18f8a05ac289b3',

        '6e370fba9bbcbffce1d6',

        '7529a30f4c5d30b0757a',

        '6999740be2a212ca3330',

        '27ae079f8dc360a1ef4b',

        '09d516efc611e66154c9',

        '35c0d926abf47eaf3c8a',

        'b8bc4d43c5c8f4cac63a',

        '66103d632adb495bb27f',

        '56d059e064ace1467033',

        'e4feee6d6a365f7a3f87',

        '03d3d915ef49c43a233c',

        '89b8f4044a82351a5c2c',

        '7e5108d3d108cb685d2e',

        '5b54d7a2816ae18f6cad',

        '2b0d56b0d9a03b8b5d72',

        '554f37155c31e0399828',

        'ba0c27ea2feb85573c9f',

        '5fbeaf4f1c72c6a31489',

        '7bfa32b1df4c1aeca586',

        '4212101edbc8483cdeb5',

        '561e387696a0bb5fc596',

        '2b28ae9acaf33e68dd94',

        '2fe9a3b4dc84056004ec',

        '27e427de53fa4af2c430',

        '9261df3db875c3a3a61d',

        '9cb2e0c9c49865c6e4b6',

        '454d719a471f967ced16',

        '1680e68dd7fc06c532d2',

        'e159b4dc2fc29d5df3fe',

        '046d2982d0140bd4389a',

        '38f9f802b34dd133b801',

        'b0dcb9805ecc642aa521',

        '7b05b422c3d4aab1755d',
        '91f7628bea20fb9c0f39',


        //  新增
        'c93833b91a2547ee7156',
        '14d9ed7a6f99667f4883',
        '47fbee268fae6d47d61d',
        '509701e16054681f7045',
        '90f9bc674b4e666f092f',
        'c166b81e21db033dd623',
        '06e1f160f5c5ae786d05',
        'a733123ef81bd1c05ea2',
        '74363618c478c950eb02',
        '813a7b1895bdcf05b7c8',
        '53623f68272579df764f',
        '3b636596fb0d37738cfe',
        '0ebac0a7125dc1033a3b',
        '3fcfbb8c73465ccb10ac',
        'cb0e4050d7cbf1dbcab2',
        'ea763186f1f58e149a38',
        'cc2f56a78779f44b08ae',
        '40f017c8925003428da6',
        'd02096dc3d5fd51b2f15',
        '8362fb9f4204709b0fdc',
        '8362fb9f4204709b0fdc',
        '52be3c5baf61e35b40b7',
        'ddd74a2095e49acdf88d',
        'e6f759871b27090ea14d',
        '1630e53118907b1086c2',
        '0cf73e9c33de298123a4',
        'f88ef7526fa64db3b8b5',
        '03adf1faf9719f57dce8',
        '713010bf3addd631cef5',
        'e7ecc202d67ec7740be9',
        '5650afdd2fe370875dee',
        'a3f2ccc00d596b99ecf9',
        'f7af1d45a95ef681ea03',
        '85158c0b2e899496cc8c',
        '4065c10da9e6b64f2deb',
        'bae4059afe366349d737',
        '6179e136b60559d84d05',
        '3395a32d7fc1ec8ba779',
        'c47d9f975fd88b54439e',
        'a2b7cf7f7208e9499fb6',
        'cc4936252de72b07c137',
        'c93833b91a2547ee7156',
        '14d9ed7a6f99667f4883',
        '47fbee268fae6d47d61d',
        '509701e16054681f7045',
        '90f9bc674b4e666f092f',
        'c166b81e21db033dd623',
        '06e1f160f5c5ae786d05',
        'a733123ef81bd1c05ea2',
        '74363618c478c950eb02',
        '813a7b1895bdcf05b7c8',
        '53623f68272579df764f',
        '3b636596fb0d37738cfe',
        '0ebac0a7125dc1033a3b',
        '3fcfbb8c73465ccb10ac',
        'cb0e4050d7cbf1dbcab2',
        'ea763186f1f58e149a38',
        'cc2f56a78779f44b08ae',
        '40f017c8925003428da6',
        'd02096dc3d5fd51b2f15',
        '8362fb9f4204709b0fdc',
        '52be3c5baf61e35b40b7',
        'ddd74a2095e49acdf88d',
        'e6f759871b27090ea14d',
        '1630e53118907b1086c2',
        '0cf73e9c33de298123a4',
        'f88ef7526fa64db3b8b5',
        '03adf1faf9719f57dce8',
        '713010bf3addd631cef5',
        'e7ecc202d67ec7740be9',
        '5650afdd2fe370875dee',
        'a3f2ccc00d596b99ecf9',
        'f7af1d45a95ef681ea03',
        '85158c0b2e899496cc8c',
        '4065c10da9e6b64f2deb',
        'bae4059afe366349d737',
        '6179e136b60559d84d05',
        '3395a32d7fc1ec8ba779',
        'c47d9f975fd88b54439e',
        'a2b7cf7f7208e9499fb6',
        'cc4936252de72b07c137',

      ],




      //数据
      dingshi:true,
      values: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      time:'',
      value1: '',
      value2: '',
      datas:[],
      datadata:[],
      temp:[],
      temp1:[],
      temp2:[],
      temp3:[],

      startDate:'20220701',
      endDate:'20220710',
      namedata:[],
      datanums:[
        {
          nuMshowCount:0,
          nuMclickCount:0,
          nuMspent:0,
          nuMformsubmitCount:0,
          nuMdisGeneralBalance:0,
          nuMbalance:0,
          nuMcustomPayCount:0,
          nuMreactivation:0,
          nuMcustomRetainCount:0
        }
      ],
      qiliangcode:0,
      sks:'',
      list:[],
      money:200,
      money2:0.5,
      money3:0.0,
      moneys:0.0,
      max:0,
      ctrJson:[{
        nameid:'',
        CTR:0,
        CVR:0,
        CLR:0,
        but:0,
        zdycl:0,
        zdyff:0,
        zdylh:0,
        xe:0,

      }],
      playCode:[],
      Newswicth:[],
      map:new Map,
      groudId:[],
      kaiguan:0,
      adids:'',
      numtest:[],
      planid:[],
      groudId1:[],
    }
  },
  methods:{
    /**一键起量
     *
     *
     * @param pams
     * @returns {Promise<void>}
     * @constructor
     */
    async Postoffer1(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/updateFastFlow?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "groupId":pams.id,
          "fastFlowBudget":pams.ocpxPrice,
          "fastFlowState":pams.price
        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '一键起量失败'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '一键起量成功',
            type: 'success'
          });

        }

      })


    },
    async Postoffer(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditPrice?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids":pams.id,
          "ocpxPrice":pams.ocpxPrice,
          "price":pams.price
        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改二阶段出价失败'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改二阶段出价成功',
            type: 'success'
          });

        }

      })


    },
    SendOffer(){
      console.log(this.groudId)
      let t2=this.money3*100000
      let t3=this.money2*100000
      for (let a in this.groudId){
        let t1={
          id:this.groudId[a],
          ocpxPrice:t2,
          price:t3,
          token:this.sks,
          adid:this.adids
        }
        this.Postoffer(t1)
      }

      this.offer=false
    },
    SendOffer1(){
      console.log(this.groudId)
      let t2=this.moneys*100000
      let t3=this.money2*100000
      for (let a in this.groudId){
        let t1={
          id:this.groudId[a],
          ocpxPrice:t2,
          price:1,
          token:this.sks,
          adid:this.adids
        }
        this.Postoffer1(t1)
      }

      this.offer=false
    },
    SendOffer2(){
      console.log(this.groudId)
      let t2=this.moneys*100000
      let t3=this.money2*100000
      for (let a in this.groudId){
        let t1={
          id:this.groudId[a],
          ocpxPrice:t2,
          price:3,
          token:this.sks,
          adid:this.adids
        }
        this.Postoffer1(t1)
      }

      this.offer=false
    },
    async chujia(index, row) {
      this.money3=0;
      this.max=0;
      let pams = {
        //危险
        token: this.sks,
        adid: row.uuid,
        adName: row.adName,
        campaignId: row.campaignId
      }
      this.adids = row.uuid
      await this.PostGroup3(pams)
      await this.yijianqiliangcode(pams)

      this.max=this.numtest[0].ocpxPrice;
      if (this.numtest.length=1){
        this.money3=this.numtest[0].ocpxPrice;
      }else{
        for (let i=1;i<this.numtest.length;i++){
          console.log(this.numtest[i].ocpxPrice)
          if(this.numtest[i].ocpxPrice>this.max){
            this.money3=this.numtest[i].ocpxPrice;
          }else{
            this.money3=this.max

          }

        }
      }

      this.money3=this.money3/100000
      this.offer = true;
    },
    updateEd1(){
      console.log(this.kaiguan)
      if(this.kaiguan===0){
        let t1={
          id:this.grouplist.campaignId,
          dailyBudget:-1,
          token:this.sks,
          adid:this.grouplist.userId
        }
        this.PostMoeny(t1)
      }else if (this.kaiguan===1){
        let t1={
          id:this.grouplist.campaignId,
          dailyBudget:this.money*100000,
          token:this.sks,
          adid:this.grouplist.userId
        }
        this.PostMoeny(t1)


      }



      this.dialog2=false

    },

//修改限额api
    edit1(row){
      console.log(row)
      this.grouplist={}
      this.grouplist={
        campaignId:row.campaignId,
        userId:row.userId,
      }
      this.dialog2=true
    },
    async PostMoeny(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/editDailyBudget?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "id":pams.id,
          "dailyBudget":pams.dailyBudget,
        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改限额失败，请检测限额是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改限额成功',
            type: 'success'
          });

        }

      })


    },
    async yijianqiliangcode(pams){
      this.groudId1=[]
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/getFastFlowInfoByGroupIds?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "groupIds":this.groudId[0],
        }).then(resp=>{
        // console.log(resp.data[0].fastFlowState)
        if (resp.data.data===undefined){
          this.qiliangcode=0;
        }else {
          console.log(resp.data.data)
          this.qiliangcode=resp.data.data[0].fastFlowState;


        }
        // if (resp.data.datas[0])
      })


    },
    async PostGroup1(pams){

      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditDate?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids":pams.ids,
          "startDate":pams.startDate,
          "endDate":pams.endDate
        }).then(resp=>{

        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改投放日期失败，请检查日期是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改投放日期成功',
            type: 'success',
            position: 'bottom-left'
          });
        }

      })


    },
    async updateTime1() {
      // for(let a=0;a<this.datas.length;a++){
      //   console.log(this.datas[a].uuid)
      // }
      for (let a = 0; a < this.datas.length; a++) {
        this.groudId=[]
        let parms = {
          token: this.sks,
          adid: this.datas[a].uuid,
        }
        // console.log(parms)
        await this.queryPlanId(parms)
        console.log(this.planid)
        for (let key in this.planid) {
          let pams={
            //危险
            token:this.sks,
            adid: this.datas[a].uuid,
            campaignId:this.planid[key],
          }
          this.adids = this.datas[a].uuid,
            await this.PostGroup4(pams)

          // console.log(this.groudId)
        }
        let endtime = '2038-01-19'
        if (this.kaiguan === 0) {
          //发送
          for (let a = 0; a < this.groudId.length; a++) {
            let pams = {
              ids: this.groudId[a],
              startDate: this.value3,
              endDate: endtime,
              token: this.sks,
              adid: this.adids
            }

            await this.PostGroup1(pams)
          }

        } else if (this.kaiguan === 1) {
          for (let a = 0; a < this.groudId.length; a++) {
            let pams = {
              ids: this.groudId[a],
              startDate: this.value2.at(0),
              endDate: this.value2.at(1),
              token: this.sks,
              adid: this.adids
            }
            await  this.PostGroup1(pams)
          }
        }
        if(a===this.datas.length-1){
          alert("批量关闭OK")
          this.dialog3 = false
        }
      }

    },
    //投放时间方法提交
    async updateTime() {
      let endtime = '2038-01-19'
      if (this.kaiguan === 0) {
        //发送
        for (let a = 0; a < this.groudId.length; a++) {
          let pams = {
            ids: this.groudId[a],
            startDate: this.value3,
            endDate: endtime,
            token: this.sks,
            adid: this.adids
          }

          await this.PostGroup1(pams)
        }

      } else if (this.kaiguan === 1) {
        for (let a = 0; a < this.groudId.length; a++) {
          let pams = {
            ids: this.groudId[a],
            startDate: this.value2.at(0),
            endDate: this.value2.at(1),
            token: this.sks,
            adid: this.adids
          }
          await  this.PostGroup1(pams)
        }
      }

      this.dialog1 = false
    },
    //面板状态

    //面板状态
    boo(tab) {
      if(tab.name==="first"){
        this.kaiguan=0
      }else if (tab.name==="second"){
        this.kaiguan=1
      }else if (tab.name==="two"){
        this.kaiguan=2
      }else if(tab.name==="second1"){
        this.kaiguan=3
      }else if(tab.name==="second2"){
        this.kaiguan=4
      }else if(tab.name==="second3"){
        this.kaiguan=5
      }else if(tab.name==="second4"){
        this.kaiguan=6
      }else if(tab.name==="second5"){
      }else if(tab.name==="second5"){
        this.kaiguan=7
      }else if(tab.name==="two2"){
        this.kaiguan=8
      }else if(tab.name==="two4"){
        this.kaiguan=9
      }else if(tab.name==="two5"){
        this.kaiguan=10
      }
      else if(tab.name==="two6"){
        this.kaiguan=11
      }






    },
    //修改日期
    async PostGroupTime(pams){

      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditTime?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids":pams.ids,
          "scheduleTime":pams.scheduleTime,

        }).then(resp=>{

        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改投放时段失败，请检查时段是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改投放时段成功',
            type: 'success',
            position: 'bottom-left'
          });
          this.dialog=false
        }

      })


    },
    async PostGroup2(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/advertisement/pageInfo?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "campaignId":pams.campaignId,
        }).then(resp=>{

        console.log(resp.data.data.list)
        for (let key in resp.data.data.list){
          // this.groudId[key]=resp.data.data.list[key].groupId
          this.groudId.push(resp.data.data.list[key].groupId)
        }

      })

    },
    async PostGroup(pams){
      this.groudId=[]

      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/advertisement/pageInfo?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "campaignId":pams.campaignId,
        }).then(resp=>{

        console.log(resp.data.data.list)
        for (let key in resp.data.data.list){
          this.groudId[key]=resp.data.data.list[key].groupId
        }

      })

    },
    async PostGroup4(pams){
      console.log(pams.campaignId)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/pageInfo?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "campaignId":pams.campaignId,
        }).then(resp=>{
        console.log(resp.data.data)

        for (let key in resp.data.data.list){
          // console.log("广告组id")
          // console.log(resp.data.data.list)
          this.groudId.push(resp.data.data.list[key].id)
        }
        this.numtest=resp.data.data.list

      })
    },
    async PostGroup3(pams){
      this.groudId=[]
      this.value3='';
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/pageInfo?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "campaignId":pams.campaignId,
        }).then(resp=>{
        for (let key in resp.data.data.list){
          this.value3=this.timestampToTime(resp.data.data.list[key].startDate)
          this.groudId[key]=resp.data.data.list[key].id
        }
        this.numtest=resp.data.data.list

      })
    },
    //投放时间
    async updateEd() {
      if (this.kaiguan === 0) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }

      } else if (this.kaiguan === 1) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 2) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 3) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111000000000000000011111111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 4) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 5) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 6) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 7) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 8) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 9) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 10) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111'
          }
          await this.PostGroupTime(parm)
        }
      } else if (this.kaiguan === 11) {
        for (let a = 0; a < this.groudId.length; a++) {
          let parm = {
            token: this.sks,
            adid: this.adids,
            ids: this.groudId[a],
            scheduleTime: '000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111'
          }
          await this.PostGroupTime(parm)
        }
      }

    },
    //查询计划
    async queryPlanId(parms){
      let nonce= Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/pageInfo?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid, {
        pageSize:'100'
      }).then(async resDay => {

        for (let key in resDay.data.data.list){

          this.planid[key]=resDay.data.data.list[key].id
        }

      })

    },
    //显示表单
    async handleClick(row) {
      if (this.values === "ACCOUNT") {
        this.groudId=[]
        let parms = {
          token: this.sks,
          adid: row.uuid,
        }
        await this.queryPlanId(parms)
        this.dialog = true;
        for (let key in this.planid) {
          let pams={
            //危险
            token:this.sks,
            adid:row.uuid,
            campaignId:this.planid[key],
          }
          this.adids = row.uuid

          await this.PostGroup2(pams)

        }
      } else {
        this.dialog = true;
        let pams = {
          //危险
          token: this.sks,
          adid: row.uuid,
          campaignId: row.campaignId,
        }
        this.adids = row.uuid

        await this.PostGroup(pams)
      }


    },

    //投放日期
    async edit(row){
      if (this.values === "ACCOUNT") {
        this.groudId=[]
        let parms = {
          token: this.sks,
          adid: row.uuid,
        }
        // console.log(parms)
        await this.queryPlanId(parms)

        this.dialog1=true;
        console.log(this.planid)
        for (let key in this.planid) {
          let pams={
            //危险
            token:this.sks,
            adid:row.uuid,
            adName:row.adName,
            campaignId:this.planid[key],
          }
          this.adids = row.uuid
          await this.PostGroup4(pams)

          // console.log(this.groudId)
        }
      }else {
        console.log(this.value3)
        let pams={
          //危险
          token:this.sks,
          adid:row.uuid,

          adName:row.adName,
          campaignId:row.campaignId
        }
        this.adids=row.uuid
        this.PostGroup3(pams)
        this.dialog1=true;

      }


    },

    timestampToTime(timestamp) {
      let date = new Date(timestamp)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-'
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      let D = date.getDate() + ' '
      let h = date.getHours() + ':'
      let m = date.getMinutes() + ':'
      let s = date.getSeconds()
      console.log(Y + M + D + h + m + s)
      return Y + M + D
    },

//切换开关
    changeSwitch(value,row,index){
      if (this.userUalue[1]==="mrqy") {
        let time1 = parseInt(new Date().getTime()) + '';
        let nonce = Math.round(Math.random() * 100000000000)
        const {id, pauseState, userId} = row

        let params = {
          userId: userId,
          id: id,
          pauseState: pauseState ? '1' : '0'  // 三元运算符  类似于if else
        };

        this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token=' + this.sks + '&timestamp=' +
          time1 + '&nonce=' + nonce + '&advertiser_id=' + params.userId, {
          ids: params.id,
          startAndStop: params.pauseState
        }).then(async res => {
          if (res.data.code === 0) {
            this.$message.success(`${pauseState ? '已停用' : '已启用'}`)
          }
        })

      }else {
        let time1 = parseInt(new Date().getTime()) + '';
        let nonce = Math.round(Math.random() * 100000000000)
        const {id, pauseState, userId} = row

        let params = {
          userId: userId,
          id: id,
          pauseState: pauseState ? '1' : '0'  // 三元运算符  类似于if else
        };

        this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token=' + this.sks + '&timestamp=' +
          time1 + '&nonce=' + nonce + '&advertiser_id=' + params.userId, {
          ids: params.id,
          startAndStop: params.pauseState
        }).then(async res => {
          if (res.data.code === 0) {
            this.$message.success(`${pauseState ? '已停用' : '已启用'}`)
          }
        })

      }

    },
    //汇总 格式化合计行
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      if (this.values==="ACCOUNT"){ //账户层级
        let a=0;

        columns.forEach((column, index) => {

          if (index === 0) {
            sums[index] = '总汇';
            return;
          }

          if (index === 5) {
            sums[index] = sums[index-1]/sums[index-2];
            sums[index]=sums[index].toFixed(3);
            sums[index]=sums[index]*100
            sums[index]= sums[index]+'%'
            sums[index]=sums[index]
            return;

          }

          if(index===8){

            sums[index] = sums[index-2]/sums[index-4];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;
          }
          if (index === 10) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 12) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }

          if (index === 15) {
            sums[index] = sums[index-4]/sums[index-11];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100
            sums[index]= sums[index]+'%'

            sums[index]=sums[index]
            return;

          }
          if (index === 13) {

            return;

          }
          if (index === 16) {

            return;

          }
          if (index === 7) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }

        });
        return sums;
      }
      else if(this.values==="CAMPAIGN"){ //账户层级
        let a=0;

        columns.forEach((column, index) => {

          if (index === 0) {
            sums[index] = '总汇';
            return;
          }

          if (index === 7) {
            sums[index] = sums[index-1]/sums[index-2];
            sums[index]=sums[index].toFixed(3);
            sums[index]=sums[index]*100
            sums[index]= sums[index]+'%'
            sums[index]=sums[index]
            return;

          }

          if(index===10){

            sums[index] = sums[index-2]/sums[index-4];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;
          }
          if (index === 12) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 14) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {

            return;

          }
          if (index === 16) {

            return;

          }
          if (index === 17) {
            sums[index] = sums[index-4]/sums[index-11];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100
            sums[index]= sums[index]+'%'

            sums[index]=sums[index]
            return;

          }

          if (index === 18) {

            return;

          }
          if (index === 9) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }

        });
        return sums;
      }else if(this.values==="GROUP"){ //广告组层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }  if (index === 9) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index] =  sums[index].toFixed(2) ;
            return;

          }
          if (index === 6) {
            sums[index] = sums[index-1]/sums[index-2];
            sums[index]=sums[index]*100
            sums[index]=sums[index].toFixed(2);
            sums[index]= sums[index]+'%'
            return;

          }
          if (index === 11) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 13) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {
            sums[index] = sums[index-8]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 16) {
            sums[index] = sums[index-8]/sums[index-11];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }
          if (index === 17) {
            sums[index] = sums[index-5]/sums[index-9];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }



          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }

    },
    //导出文档api
    exportExcel() {
      excel('exportTab','数据导出')
    },


    //表单格式规则
    rule(row,column){
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property]).toFixed(2)
        return percent
      }
    },
    //加百分号
    ChangeToPercentage: function(row, column) {
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property] * 100).toFixed(2) + '%'
        return percent
      }

    },
    timerule(row,column){
      if (row[column.property]===undefined){
        return  1;
      }else {
        console.log(column.property)
        var ttime = row[column.property];

        var pattern = /(\d{4})(\d{2})(\d{2})/;
        var formatedDate = ttime.toString().replace(pattern, '$1-$2-$3');

        console.log(formatedDate);


        return formatedDate
      }

    },
    rule1(row,column){

      if (row[column.property]===-1){
        return '未限额'
      }else {
        var percent = row[column.property]/100000
        return percent
      }
    },
    // 获取时间戳，获取时间选择器时间
    chooseTimeRange(value1){
      this.time = parseInt(new Date().getTime()) + '';
      this.value2=value1;

    },
    //查询函数
    async getDataList1(){
      this.dialog3=true

    },
    getDataList() {
      //清空列表，数组
      this.time = parseInt(new Date().getTime()) + '';
      this.datanums[0].nuMshowCount=0
      this.datanums[0].nuMclickCount=0
      this.datanums[0].nuMspent=0
      this.datanums[0].nuMformsubmitCount=0
      this.datanums[0].nuMbalance=0
      this.datanums[0].nuMdisGeneralBalance=0
      this.datanums[0].nuMcustomPayCount=0
      this.datanums[0].nuMreactivation=0
      this.datanums[0].nuMcustomRetainCount=0
      this.datas=null
      this.datadata=[]
      this.namedata=[]
      this.playCode=[]
      this.temp2=[]
      this.temp1=[]
      this.temp=[]

      //判断是否为小白进入下方，查询按钮禁用
      if(this.userUalue[0]==="xiaobai"){
        this.isDisable = true
        //调起接口
        this.TimeChangeto1();
      }

    },
    //合并json
    hb(jsonbject1, jsonbject2) {
      var resultJsonObject = {};
      for (var attr in jsonbject1) {
        resultJsonObject[attr] = jsonbject1[attr];
      }
      for (var attr in jsonbject2) {
        resultJsonObject[attr] = jsonbject2[attr];
      }
      return resultJsonObject;
    },
    //按天查询所有户
    async queryDay(list){
      let nonce= Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + list.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + list.adid[list.a], {
        startDate: list.startDate,
        endDate: list.endDate,
        pageIndex: "1",
        pageSize: "100",
        summaryType: "DAY",
        level: list.level
      }).then(async resDay => {
        this.len=resDay.data.data.items.length;
        return resDay;
      })
    },
    //查询广告
    async PostListQuery(parms){

      this.$message.success("正在查询第"+parms.a+"条")
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a], {
        startDate: parms.startDate,
        endDate: parms.endDate,
        pageIndex: "1",
        pageSize: "100",
        summaryType: parms.summaryType,
        level: parms.level
      }).then(async resp => {
        if (resp.data.code!==60806){
          if (resp.data.data.items !=null){
            if (this.value==="HOUR"){
              let arr=[];
              arr=[];
              let map=new Map;
              map.clear();
              for(let key in resp.data.data.items){
                var time=new Date(resp.data.data.items[key].reportTime)
                let reTimeHour=time.getHours(); //获取返回整点时间
                var date=new Date()
                let hour=date.getHours();  // 获取当前时间
                if (hour===reTimeHour){
                  arr.push(key)   //定位现在整时位置
                  map.set(key,resp.data.data.items[key])// 记录下现在的数据
                }
              }
              for (let keys in arr){

                this.datadata.push(map.get(arr[keys]))
                let obj={
                  ids:resp.data.data.items[arr[keys]].campaignId,
                  lengths:arr.length
                }
                let pams=Object.assign(obj,parms)
                await this.PostListplayCode(pams)
              }
              let obj1={
                lengths:arr.length
              }
              parms=Object.assign(obj1,parms)
              await this.GetListUserId(parms);

            }else{
              for (let b=0;b<resp.data.data.items.length;b++){
                this.datadata.push(resp.data.data.items[b])
                let obj={
                  ids:resp.data.data.items[b].campaignId,
                  lengths:resp.data.data.items.length
                }
                let pams=Object.assign(obj,parms)
                await this.PostListplayCode(pams)
              }
              let obj1={
                lengths:resp.data.data.items.length
              }
              parms=Object.assign(obj1,parms)
              await this.GetListUserId(parms);

            }

          }
        }

      })

    },
    // 查询计划状态
    async PostListplayCode(pams){

      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/pageInfo?access_token='+ pams.token + '&timestamp=' + this.time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid[pams.a],
        {
          "ids":pams.ids,
        }).then(resps=>{
        if (resps.data.data.list===undefined){
          this.playCode.push({pauseState:1})
        }else {
          this.playCode.push(resps.data.data.list[0])
        }
      })
    },
    //查询账号信息
    async GetListUserId(parms){
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a])
        .then(async res => {
            if (res.data.message == '请求成功') {
              //测试
              if (this.value==="HOUR"){
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }else{
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }
            } else {

            }
          }

        )
    },
    //服务请求
    async TimeChangeto1 () {
      //判断是哪个户
      this.sks=this.xiaobai[0]
      if (this.userUalue[1]==="mrqy"){
        for (let a = 0; a < this.mrqy.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.mrqy
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))

        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="fjsk"){
        this.sks=this.fjsktoken[0]
        for (let a = 0; a < this.fjsk.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.fjsk
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        console.log(this.temp1)
        for (let key=0;key<this.temp.length;key++){
          //h换名字

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp1[key].dataVersion=this.temp1[key].dailyBudget
          //wzs
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].backActivateCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        console.log(this.temp2)
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="qexs"){
        this.sks=this.xiaobai[1]
        for (let a = 0; a < this.qexs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.qexs
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="xgjc"){
        this.sks=this.xgjctoken[0]
        for (let a = 0; a < this.xgjc.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.xgjc
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="csyh"){
        this.sks=this.csyhtoken[0]
        for (let a = 0; a < this.csyh.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.csyh
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="fhxs"){
        this.sks=this.fhxstoken[0]
        for (let a = 0; a < this.fhxs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.fhxs
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="hmxs"){
        this.sks=this.hmxstoken[0]
        for (let a = 0; a < this.hmxs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.hmxs
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="ssxs"){
        this.sks=this.ssxstoken[0]
        for (let a = 0; a < this.ssxs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.ssxs
          }
          await this.PostListQuery(parms)
        }

        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        console.log(this.temp1)
        for (let key=0;key<this.temp.length;key++){
          //h换名字

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp1[key].dataVersion=this.temp1[key].dailyBudget
          //wzs
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        console.log(this.temp2)
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="jhcm"){
        this.sks=this.jhcmtoken[0]
        for (let a = 0; a < this.jhcm.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.jhcm
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        console.log(this.temp1)
        for (let key=0;key<this.temp.length;key++){
          //h换名字

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp1[key].dataVersion=this.temp1[key].dailyBudget
          //wzs
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        console.log(this.temp2)
        this.datas=this.temp2
        this.isDisable = false

      }

      if (this.userUalue[1]==="zjsk"){
        this.sks=this.zjsktoken[0]
        for (let a = 0; a < this.zjsk.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.zjsk
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        console.log(this.temp1)
        for (let key=0;key<this.temp.length;key++){
          //h换名字

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp1[key].dataVersion=this.temp1[key].dailyBudget
          //wzs
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        console.log(this.temp2)
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="klks"){
        this.sks=this.klkstoken[0]
        for (let a = 0; a < this.klks.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.klks
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="xqqqexs"){
        this.sks=this.ssxstoken[0]
        for (let a = 0; a < this.xqqqexs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.xqqqexs
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="xqqhmxs"){
        this.sks=this.ssxstoken[1]
        for (let a = 0; a < this.xqqhmxs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.xqqhmxs
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="xqqhtxs"){
        this.sks=this.ssxstoken[2]
        for (let a = 0; a < this.xqqhtxs.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.xqqhtxs
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="chssxs"){
        this.sks=this.ssxstoken[0]
        for (let a = 0; a < this.ch.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.ch
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="hxzssxs"){
        this.sks=this.ssxstoken[0]
        for (let a = 0; a < this.hxz.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.hxz
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="whssxs"){
        this.sks=this.ssxstoken[0]
        for (let a = 0; a < this.wh.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.wh
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字
          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="dzff"){
        this.sks=this.xiaobai[2]
        for (let a = 0; a < this.dzff.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.dzff
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }
      if (this.userUalue[1]==="modj"){
        this.sks=this.modjtoken[0]
        for (let a = 0; a < this.modj.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token: this.sks,
            adid:this.modj
          }
          await this.PostListQuery(parms)
        }
        this.temp=JSON.parse(JSON.stringify(this.datadata))
        this.temp1=JSON.parse(JSON.stringify(this.namedata))
        this.temp3=JSON.parse(JSON.stringify(this.playCode))
        for (let key=0;key<this.temp.length;key++){
          //h换名字

          this.ctrJson[0].nameid=this.temp1[key].name
          this.temp1[key].disGeneralBalance=this.temp1[key].balance/100000
          this.temp2[key]=this.hb(this.temp1[key],this.temp[key])
          this.ctrJson[0].xe=this.temp1[key].dailyBudget

          this.ctrJson[0].but=this.temp2[key].spent/this.temp2[key].clickCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat( this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
          this.ctrJson[0].CTR=this.temp2[key].clickCount/this.temp2[key].showCount
          this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
          let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
          this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);
          this.ctrJson[0].CVR=this.temp2[key].addDesktopCount/this.temp2[key].clickCount
          this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
          let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
          this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
          this.ctrJson[0].CLR=this.temp2[key].customRetainCount/this.temp2[key].formsubmitCount
          this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
          let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
          this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);
          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customPayC;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].addDesktopCount;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);

          this.temp2[key]=this.hb(this.temp2[key],this.ctrJson[0])
          this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])

        }
        this.temp2=JSON.parse(JSON.stringify(this.temp2))
        this.datas=this.temp2
        this.isDisable = false

      }

    },
  },
  created () {  },
}

</script>













































































































































































// WEBPACK FOOTER //
// src/components/peixun.vue